<template>
	<vs-popup
		class="popup-container"
		:active.sync="popupActive"
		fullscreen
		:title="
			'Backlinks N° Contrat ' + $props.contractId + ' - ' + $props.societyName
		"
	>
		<!-- ✅ NOUVEAU : Popup de confirmation pour changement de statut -->
		<vs-popup
			class="status-change-popup"
			:active.sync="statusChangePopupActive"
			style="z-index: 100000 !important"
			title="Confirmation de changement de statut"
		>
			<div class="popup-content">
				<div class="warning-icon">
					<i
						class="feather icon-alert-triangle"
						style="font-size: 48px; color: #ff9800"
					></i>
				</div>

				<h3>Le statut va passer à inactif</h3>

				<p>Voulez-vous supprimer l'achat associé à ce backlink ?</p>

				<div class="popup-actions">
					<vs-button color="success" @click="confirmStatusChange(true)">
						Oui, supprimer l'achat
					</vs-button>

					<vs-button color="primary" @click="confirmStatusChange(false)">
						Non, conserver l'achat
					</vs-button>

					<vs-button color="danger" @click="cancelStatusChange()">
						Annuler
					</vs-button>
				</div>
			</div>
		</vs-popup>

		<!-- ✅ NOUVEAU : Popup de confirmation pour les doublons -->
		<vs-popup
			class="status-change-popup"
			:active.sync="duplicationConfirmationPopup"
			style="z-index: 100000 !important"
			title="Confirmation des doublons détectés"
		>
			<div class="popup-content">
				<div class="warning-icon">
					<i
						class="feather icon-alert-triangle"
						style="font-size: 48px; color: #ff9800"
					></i>
				</div>

				<h3>Des doublons ont été détectés</h3>
				<p>Les netlinks suivants existent déjà dans la base de données :</p>

				<vs-table
					stripe
					:data="matchingUrls"
					id="tb"
					class="mt-5"
					noDataText="Aucun doublon trouvé"
				>
					<template slot="thead">
						<vs-th class="th-sticky" style="pointer-events: auto">Client</vs-th>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Contrat</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Prestation</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Url Backlinks</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Landing Page</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Periode</vs-th
						>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="index" v-for="(item, index) in data">
							<vs-td :data="item.society_id">
								{{ getSocietyName(societies, item.society_id) }}
							</vs-td>
							<vs-td :data="item.contract_id">
								{{ item.contract_id }}
							</vs-td>
							<vs-td :data="item.mission_id">
								{{ getMissionName(missions, item.mission_id) }}
							</vs-td>
							<vs-td :data="item.url_bought">
								{{ item.url_bought }}
							</vs-td>
							<vs-td :data="item.landing_page">
								{{ item.landing_page }}
							</vs-td>
							<vs-td :data="item.period_date">
								{{ item.period_date }}
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>

				<div class="popup-actions">
					<vs-button
						color="primary"
						@click="duplicationConfirmationPopup = false"
						:disabled="isSaving"
					>
						Modifier
					</vs-button>
					<vs-button
						v-if="!isSaving"
						color="success"
						@click="saveAllChanges()"
						:disabled="isSaving"
					>
						<span>Continuer (Mettre à jour les doublons)</span>
					</vs-button>
					<div v-else>
						<CircularLoader />
					</div>
				</div>
			</div>
		</vs-popup>

		<div style="height: 100%; width: 100%">
			<div class="example-wrapper">
				<!-- ✅ NOUVEAU : Section de filtres -->
				<div class="filter-section">
					<h4>Filtres</h4>
					<div class="filter-row">
						<div class="filter-item">
							<label>URL Backlink</label>
							<vs-input
								type="text"
								v-model="queries.url_link"
								placeholder="Filtrer par URL"
								@input="applyFilters"
							/>
						</div>
						<div class="filter-item">
							<label>Statut</label>
							<vs-select
								autocomplete
								multiple
								v-model="queries.status"
								class="w-full select-medium"
								placeholder="Statut"
								@change="applyFilters"
							>
								<vs-select-item
									:key="index"
									:value="item.status_value"
									:text="item.status_text"
									v-for="(item, index) in netlinkStatus"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="filter-item">
							<label>Prestation</label>
							<select v-model="queries.mission_id">
								<option value="">Toutes</option>
								<option
									v-for="mission in missions"
									:key="mission.id"
									:value="mission.id"
								>
									{{ mission.id }} - {{ mission.perform }}
								</option>
							</select>
						</div>

						<div class="filter-item">
							<label>Prestataire</label>
							<select v-model="queries.provider_id">
								<option value="">Tous</option>
								<option
									v-for="provider in providers"
									:key="provider.id"
									:value="provider.id"
									v-if="provider.id !== null"
								>
									{{ provider.society }}
								</option>
							</select>
						</div>
						<div class="filter-item">
							<label>Type de lien</label>
							<select v-model="queries.link_type">
								<option value="">Tous</option>
								<option
									v-for="type in linkTypes"
									:key="type.id"
									:value="type.id"
									v-if="type.id !== null"
								>
									{{ type.name }}
								</option>
							</select>
						</div>
						<div class="filter-item">
							<label>Etat du lien</label>
							<vs-select
								autocomplete
								multiple
								v-model="queries.additional_link_type"
								class="w-full select-medium"
								placeholder="Status"
								@change="applyFilters"
							>
								<vs-select-item
									:key="index"
									:value="item.value"
									:text="item.text"
									v-for="(item, index) in additionalLinkTypes"
									class="w-full"
								/>
							</vs-select>
						</div>
					</div>

					<!-- Period filters on a separate row -->
					<div class="filter-row">
						<div class="filter-item">
							<label>Période de début</label>
							<div class="flex">
								<vx-input-group class="w-full bottom">
									<template slot="prepend">
										<div class="prepend-text bg-primary">
											<span class="flex">
												<vs-icon icon="calendar_today" size="small"></vs-icon>
											</span>
										</div>
									</template>
									<div v-if="useGestionPeriodPicker" :key="datePickerKey">
										<month-picker-input
											:max-date="maxDate"
											:default-year="thisYear"
											:default-month="thisMonth"
											:no-default="true"
											lang="fr"
											@input="onPeriodDateChange"
											placeholder="Début"
											:value="queries.period_date"
										/>
									</div>
								</vx-input-group>
								<div
									style="
										margin-left: -85px;
										margin-top: 8px;
										cursor: pointer;
										z-index: 999;
									"
									v-if="queries.period_date"
									@click="clearPeriodDate"
									title="Effacer la période de début"
								>
									X
								</div>
							</div>
						</div>
						<div class="filter-item">
							<label>Période de fin</label>
							<div class="flex">
								<vx-input-group class="w-full bottom">
									<template slot="prepend">
										<div class="prepend-text bg-primary">
											<span class="flex">
												<vs-icon icon="calendar_today" size="small"></vs-icon>
											</span>
										</div>
									</template>
									<div v-if="useGestionPeriodPicker" :key="endDatePickerKey">
										<month-picker-input
											:max-date="maxDate"
											:min-date="endPeriodMinDate"
											:default-year="endThisYear"
											:default-month="endThisMonth"
											:no-default="true"
											:disabled="isEndPeriodDisabled"
											lang="fr"
											@input="onEndPeriodDateChange"
											placeholder="Fin"
											:value="queries.end_period_date"
										/>
									</div>
								</vx-input-group>
								<div
									style="
										margin-left: -85px;
										margin-top: 8px;
										cursor: pointer;
										z-index: 999;
									"
									v-if="queries.end_period_date"
									@click="clearEndPeriodDate"
									title="Effacer la période de fin"
								>
									X
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- ✅ FIN : Section de filtres -->

				<div
					style="
						margin-bottom: 5px;
						display: flex;
						justify-content: space-between;
					"
				>
					<div class="flex">
						<vs-button
							class="action-button"
							color="primary"
							@click="onBtAddRow"
						>
							Ajouter
						</vs-button>
						<!-- 🔹 NEW: Export button -->
						<vs-button
							ref="export-netlink-button"
							icon-pack="feather"
							icon="icon-download-cloud"
							color="success"
							@click="exportNetlinks()"
							:disabled="isExporting"
						>
							{{ isExporting ? "Export en cours..." : "Exporter des netlinks" }}
						</vs-button>
					</div>
					<div style="display: flex; align-items: center; gap: 10px">
						<!-- Price summation display -->
						<div
							v-if="selectedRowsData.length > 0"
							class="price-totals"
							style="display: inline-flex !important"
						>
							<span class="total-item">
								<strong>Total PA:</strong>
								{{ convertInternationalNumberToFrenchCurrency(totalBuyPrice) }}
							</span>
							<span class="divider">|</span>
							<span class="total-item">
								<strong>Total PV:</strong>
								{{ convertInternationalNumberToFrenchCurrency(totalSellPrice) }}
							</span>
							<span class="divider">|</span>
							<span class="total-item">
								<strong>Tx Marge:</strong>
								{{ marginRate }}%
							</span>
							<span class="divider">|</span>
							<span class="total-item">
								<strong>Sélectionnés:</strong> {{ selectedRows.size }}
							</span>
						</div>
						<vs-button
							v-if="!isSaving"
							class="action-button"
							color="success"
							@click="confirmSaveChanges"
							:disabled="isSaving"
						>
							<span>Enregistrer</span>
						</vs-button>
						<div v-else>
							<CircularLoader />
						</div>
					</div>
				</div>

				<!-- ✅ NOUVEAU : Loader -->
				<div v-if="isLoading" class="loader-container">
					<circular-loader></circular-loader>
				</div>

				<ag-grid-vue
					v-else
					:key="tableKey"
					style="width: 100%; height: 730px"
					class="ag-theme-balham"
					@grid-ready="onGridReady"
					:rowHeight="40"
					:columnDefs="columnDefs"
					:defaultColDef="defaultColDef"
					:editType="editType"
					:rowData="filteredNetlinks"
					@cell-value-changed="onCellValueChanged"
					@row-value-changed="onRowValueChanged"
					:rowSelection="'multiple'"
					@selection-changed="onSelectionChanged"
					:tooltipShowDelay="100"
					:tooltipHideDelay="10000"
					:getRowStyle="getRowStyle"
				></ag-grid-vue>
			</div>
		</div>
	</vs-popup>
</template>

<script>
import VueCookies from "vue-cookies";
import { AgGridVue } from "ag-grid-vue";
import NumericCellEditor from "../widgets/ag-grid/NumericCellEditor.vue";
import PeriodCellEditor from "../widgets/ag-grid/PeriodCellEditor.vue";
import Netlink from "../../entities/Netlink";
import Provider from "../../entities/Provider";
import Mission from "../../entities/Mission";
import Contract from "../../entities/Contract";
import backlinksMixins from "../../mixins/backlinksMixins";
import dbFieldConvertorMixin from "../../mixins/dbFieldConvertorMixin";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import { MonthPickerInput } from "vue-month-picker";
import moment from "moment";
import store from "@/store/store";

export default {
	name: "EditableTable",
	components: {
		AgGridVue,
		NumericCellEditor,
		PeriodCellEditor,
		CircularLoader,
		MonthPickerInput,
	},
	props: {
		popupActive: {
			type: Boolean,
			default: false,
		},
		contractId: {
			type: Number,
			default: 0,
		},
		societyName: {
			type: String,
			default: "",
		},
		societyId: {
			type: Number,
			default: null,
		},
		mission: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			isLoading: false,
			isSaving: false,
			netlinks: [],
			originalNetlinks: {},
			missions: [],
			contract: null,
			// ✅ NOUVEAU : Objet queries pour les filtres
			queries: {
				status: [], // Multiple status selection
				mission_id: "",
				period_date: "",
				end_period_date: "", // End period for range selection
				provider_id: "",
				link_type: "",
				url_link: "", // URL filter field
				additional_link_type: [], // dofollow/nofollow/unknown filter
			},
			// ✅ NOUVEAU : Propriétés pour le month picker
			useGestionPeriodPicker: true, // Set to true to use month picker, false for select dropdown
			datePickerKey: 0,
			thisMonth: null,
			thisYear: null,
			maxDate: new Date(moment().format("YYYY-MM-DD")),
			// End period picker properties
			endDatePickerKey: 0,
			endThisMonth: null,
			endThisYear: null,
			// Store grid API reference
			gridApi: null,
			// Listes pour les dropdowns
			providers: [],
			linkTypes: [],
			anchorTypes: [],
			filterOptionAnchorTypes: [],
			themas: [],
			periodList: [],
			renewDurations: [
				{ id: 0, label: "A vie" },
				{ id: 1, label: "Mensuel" },
				{ id: 12, label: "Annuel" },
			],
			facturableOptions: [
				{ id: 0, label: "Non" },
				{ id: 1, label: "Oui" },
			],
			internationalOptions: [
				{ id: 0, label: "Non" },
				{ id: 1, label: "Oui" },
			],
			netlinkStatus: [
				{ status_value: 0, status_text: "Actif" },
				{ status_value: 1, status_text: "En\u00a0attente" },
				{ status_value: 2, status_text: "Refusé" },
				{ status_value: 3, status_text: "Terminé" },
				{ status_value: 6, status_text: "Litige" },
			],
			additionalLinkTypes: [
				{ value: "dofollow", text: "Dofollow" },
				{ value: "nofollow", text: "Nofollow" },
				{ value: "unknown", text: "Unknown" },
			],
			tableKey: 0,
			// Track changes
			modifiedRows: new Set(),
			newRows: new Set(),
			deletedRows: new Set(),
			// Column definitions
			columnDefs: [],

			defaultColDef: {
				flex: 1,
				editable: true,
				cellDataType: false,
				resizable: true,
				sortable: true,
				tooltipShowDelay: 200, // Show tooltip after 200ms (0.2 seconds)
			},

			// Edit type (null disables full row editing)
			editType: null,
			// ✅ NOUVEAU : Propriétés pour la popup de changement de statut
			statusChangePopupActive: false,
			currentStatusChangeEvent: null,
			statusChangeResolver: null,
			// ✅ NOUVEAU : Timeout pour debounce des filtres
			filterTimeout: null,
			isFilterPending: false, // Show loading indicator while filter is pending
			// ✅ NOUVEAU : Propriétés pour la gestion des doublons
			duplicationConfirmationPopup: false,
			matchingUrls: [],
			nonMatchingUrls: [],

			// 🔹 NEW: Export state
			isExporting: false,
			// Checkbox selection tracking
			selectedRows: new Set(),
			selectedRowsData: [],
		};
	},
	mixins: [backlinksMixins, dbFieldConvertorMixin],
	computed: {
		hasChanges() {
			return (
				this.modifiedRows.size > 0 ||
				this.newRows.size > 0 ||
				this.deletedRows.size > 0
			);
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		// ✅ NOUVEAU : Computed pour filtrer les netlinks
		filteredNetlinks() {
			if (!this.netlinks || this.netlinks.length === 0) {
				return [];
			}

			let filtered = [...this.netlinks];

			// Filtrer par statut (multiple selection)
			if (this.queries.status && this.queries.status.length > 0) {
				filtered = filtered.filter((netlink) => {
					// Check if the netlink's status is in the selected statuses array
					return this.queries.status.includes(netlink.status);
				});
			}

			// Filtrer par prestation
			if (this.queries.mission_id !== "" && this.queries.mission_id !== null) {
				filtered = filtered.filter((netlink) => {
					return netlink.mission_id == this.queries.mission_id;
				});
			}

			// ✅ AMÉLIORÉ : Filtrer par période (gère les deux formats)
			if (
				this.queries.period_date !== "" &&
				this.queries.period_date !== null
			) {
				filtered = filtered.filter((netlink) => {
					// Check if end_period_date is provided for range filtering
					if (
						this.queries.end_period_date !== "" &&
						this.queries.end_period_date !== null
					) {
						// Date range filtering
						const startPeriod = this.queries.period_date; // e.g., "05/2025"
						const endPeriod = this.queries.end_period_date; // e.g., "11/2025"
						const netlinkPeriod = netlink.period_date; // e.g., "07/2025"

						// Check if netlink has a period_date before processing
						if (!netlinkPeriod) {
							return false; // Exclude netlinks without period_date
						}

						// Parse dates for comparison
						const [startMonth, startYear] = startPeriod.split("/").map(Number);
						const [endMonth, endYear] = endPeriod.split("/").map(Number);
						const [netlinkMonth, netlinkYear] = netlinkPeriod
							.split("/")
							.map(Number);

						// Convert to comparable numbers (YYYYMM format)
						const startNum = startYear * 100 + startMonth;
						const endNum = endYear * 100 + endMonth;
						const netlinkNum = netlinkYear * 100 + netlinkMonth;

						// Check if netlink period is within range
						return netlinkNum >= startNum && netlinkNum <= endNum;
					} else {
						// Single period filter (original behavior)
						// Si on utilise le month picker, comparer directement avec MM/YYYY
						if (this.useGestionPeriodPicker) {
							return netlink.period_date === this.queries.period_date;
						} else {
							// Si on utilise le select, comparer avec la valeur du select
							return netlink.period_date == this.queries.period_date;
						}
					}
				});
			}

			// Filtrer par prestataire
			if (
				this.queries.provider_id !== "" &&
				this.queries.provider_id !== null
			) {
				filtered = filtered.filter((netlink) => {
					return netlink.provider_id == this.queries.provider_id;
				});
			}

			// Filtrer par type de lien
			if (this.queries.link_type !== "" && this.queries.link_type !== null) {
				filtered = filtered.filter((netlink) => {
					return netlink.link_type == this.queries.link_type;
				});
			}

			// Filtrer par URL
			if (this.queries.url_link !== "" && this.queries.url_link !== null) {
				const searchTerm = this.queries.url_link.toLowerCase();
				filtered = filtered.filter((netlink) => {
					return (
						netlink.url_bought &&
						netlink.url_bought.toLowerCase().includes(searchTerm)
					);
				});
			}

			// Filtrer par etat du lien (additional_link_type)
			if (this.queries.additional_link_type && this.queries.additional_link_type.length > 0) {
				filtered = filtered.filter((netlink) => {
					return this.queries.additional_link_type.includes(netlink.additional_link_type);
				});
			}

			return filtered;
		},
		// ✅ NOUVEAU : Computed pour obtenir les netlinks existants depuis le store
		existingNetlinks() {
			return store.state.netlink || [];
		},
		societies() {
			return store.state.societies;
		},
		totalBuyPrice() {
			let total = 0;
			this.selectedRowsData.forEach((row) => {
				if (row.price) {
					total += parseFloat(row.price);
				}
			});
			return total.toFixed(2);
		},
		totalSellPrice() {
			let total = 0;
			this.selectedRowsData.forEach((row) => {
				if (row.calculated_price) {
					total += parseFloat(row.calculated_price);
				}
			});
			return total.toFixed(2);
		},
		marginRate() {
			const pv = parseFloat(this.totalSellPrice);
			const pa = parseFloat(this.totalBuyPrice);
			if (pa === 0) return "0.00";
			const margin = ((pv - pa) / pa) * 100;
			return margin.toFixed(2);
		},
		// ✅ NOUVEAU : Disable end period picker if no start period is selected
		isEndPeriodDisabled() {
			return !this.queries.period_date || this.queries.period_date === "";
		},
		// ✅ NOUVEAU : Set minimum date for end period picker based on start period
		endPeriodMinDate() {
			if (!this.queries.period_date || this.queries.period_date === "") {
				return null;
			}
			// Parse the start period date (MM/YYYY format)
			const [month, year] = this.queries.period_date.split("/").map(Number);
			// Return a Date object for the first day of the selected month
			return new Date(year, month - 1, 1);
		},
	},
	created() {
		// Charger les netlinks au démarrage et le store global
		store.dispatch("getAllNetlink");
		store.dispatch("getAllContracts");
		this.fetchDatas();
		this.getPeriodList();
	},
	methods: {
		// Method to style rows based on status
		getRowStyle(params) {
			// Status 2 = Refusé - make the row red
			if (params.data && params.data.status === 2) {
				return {
					backgroundColor: "#ffebee", // Light red background
					color: "#c62828", // Dark red text
				};
			}
			return null;
		},

		// ✅ NOUVEAU : Méthodes pour la gestion des doublons
		getMatchingUrls(newNetlinks, existingNetlinks) {
			const matches = [];

			newNetlinks.forEach((newNetlink) => {
				// Find matching existing netlink based on duplicate criteria (only check against active status = 0)
				const match = existingNetlinks.find((existing) => {
					if (
						!existing.url_bought ||
						!existing.landing_page ||
						!newNetlink.url_bought ||
						!newNetlink.landing_page
					) {
						return false;
					}

					// Only check against active netlinks (status = 0)
					if (existing.status !== 0) {
						return false;
					}

					return (
						existing.url_bought.trim() === newNetlink.url_bought.trim() &&
						existing.landing_page.trim() === newNetlink.landing_page.trim() &&
						existing.contract_id == newNetlink.contract_id &&
						existing.period_date == newNetlink.period_date
					);
				});

				if (match) {
					matches.push({
						...match,
						society_id: match.society_id,
						mission_id: match.mission_id,
						url_bought: match.url_bought,
						landing_page: match.landing_page,
						period_date: match.period_date,
					});
				}
			});

			return matches;
		},

		markDuplicateNetlinks(allNetlinks, existingNetlinks) {
			console.log("Processing all netlinks for duplicates...");
			console.log("Total netlinks:", allNetlinks.length);
			console.log("Existing netlinks count:", existingNetlinks.length);

			return allNetlinks.map((netlink, index) => {
				// Only process new netlinks
				if (!netlink._isNew) {
					return netlink; // Return unchanged for existing netlinks
				}

				console.log("Processing new netlink at index", index, ":", netlink);

				// Debug: Test specific values
				console.log("Looking for match with:", {
					url_bought: netlink.url_bought ? netlink.url_bought.trim() : "",
					landing_page: netlink.landing_page ? netlink.landing_page.trim() : "",
					contract_id: netlink.contract_id,
					period_date: netlink.period_date,
				});

				// Find if this new netlink matches an existing one (only check against active status = 0)
				const existingMatch = existingNetlinks.find((existing) => {
					// Add null/undefined checks to prevent errors
					if (
						!existing.url_bought ||
						!existing.landing_page ||
						!netlink.url_bought ||
						!netlink.landing_page
					) {
						return false;
					}

					// Only check against active netlinks (status = 0)
					if (existing.status !== 0) {
						return false;
					}

					const urlMatch =
						existing.url_bought.trim() === netlink.url_bought.trim();
					const landingMatch =
						existing.landing_page.trim() === netlink.landing_page.trim();
					const contractMatch = existing.contract_id == netlink.contract_id;
					const periodMatch = existing.period_date == netlink.period_date;

					const isMatch =
						urlMatch && landingMatch && contractMatch && periodMatch;

					if (isMatch) {
						console.log("Match details:", {
							urlMatch,
							landingMatch,
							contractMatch,
							periodMatch,
							existing: {
								url: existing.url_bought.trim(),
								landing: existing.landing_page.trim(),
								contract: existing.contract_id,
								period: existing.period_date,
							},
							new: {
								url: netlink.url_bought.trim(),
								landing: netlink.landing_page.trim(),
								contract: netlink.contract_id,
								period: netlink.period_date,
							},
						});
					}

					return isMatch;
				});

				if (existingMatch) {
					console.log("✅ Found duplicate match:", existingMatch);
					return {
						...netlink,
						_isDuplicate: true,
						_existingId: existingMatch.id,
						_isNew: true,
					};
				} else {
					console.log("❌ No duplicate found");
					return {
						...netlink,
						_isDuplicate: false,
					};
				}
			});
		},

		// ✅ Helper methods for display in popup
		getSocietyName(societies, societyId) {
			const society = societies.find((s) => s.id === societyId);
			return society ? society.name : `Société ${societyId}`;
		},

		getMissionName(missions, missionId) {
			const mission = missions.find((m) => m.id === missionId);
			return mission ? mission.perform : `Mission ${missionId}`;
		},

		// ✅ NOUVEAU : Méthode pour confirmer la sauvegarde avec vérification des doublons
		confirmSaveChanges() {
			// Stop any active editing to commit pending changes
			if (this.gridApi) {
				// Get the editing cell before stopping edit
				const editingCells = this.gridApi.getEditingCells();

				// Stop editing to commit changes
				this.gridApi.stopEditing();

				// If there was an editing cell, manually mark that row as modified (by ID)
				if (editingCells && editingCells.length > 0) {
					editingCells.forEach((cell) => {
						const rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
						if (rowNode && !rowNode.data._isNew && rowNode.data.id) {
							this.modifiedRows.add(rowNode.data.id);
						}
					});
				}
			}

			let newNetlinks = this.netlinks.filter((n) => n._isNew == true);
			this.matchingUrls = this.getMatchingUrls(
				newNetlinks,
				this.existingNetlinks
			);
			console.log("Found matching URLs:", this.matchingUrls);

			// Use the pure function and assign the result
			this.netlinks = this.markDuplicateNetlinks(
				this.netlinks,
				this.existingNetlinks
			);

			if (this.matchingUrls.length > 0) {
				this.duplicationConfirmationPopup = true;
			} else {
				this.saveAllChanges();
			}
		},

		// 🔹 NEW: Export functionality methods
		async exportNetlinks() {
			try {
				this.isExporting = true;

				// Show initial notification
				this.$vs.notify({
					title: "Export en cours",
					text: "Préparation de l'export des netlinks...",
					iconPack: "feather",
					icon: "download-cloud",
					color: "primary",
				});

				// Get filtered data for export
				const exportData = this.getFilteredNetlinksForExport();

				if (!exportData || exportData.length === 0) {
					this.$vs.notify({
						title: "Aucune donnée",
						text: "Aucun netlink ne correspond aux filtres actuels",
						iconPack: "feather",
						icon: "info",
						color: "warning",
					});
					return;
				}

				// Process and format the data for export
				const formattedExportData = this.prepareDataForExport(exportData);

				// Generate and download CSV file
				this.downloadCSV(formattedExportData, this.generateExportFilename());

				this.$vs.notify({
					title: "Export réussi",
					text: `${exportData.length} netlinks exportés avec succès`,
					iconPack: "feather",
					icon: "check-circle",
					color: "success",
				});
			} catch (error) {
				console.error("Export error:", error);
				this.$vs.notify({
					title: "Erreur d'export",
					text: "Une erreur est survenue lors de l'export des netlinks",
					iconPack: "feather",
					icon: "alert-circle",
					color: "danger",
				});
			} finally {
				this.isExporting = false;
			}
		},

		// 🔹 NEW: Get filtered netlinks for export (uses current filtered data)
		getFilteredNetlinksForExport() {
			// Return the currently filtered netlinks (which respects all applied filters)
			return this.filteredNetlinks.filter(
				(netlink) => !netlink._isNew || netlink.id
			); // Exclude unsaved new rows
		},

		// 🔹 NEW: Prepare data for export
		prepareDataForExport(netlinks) {
			return netlinks.map((netlink) => {
				// Get formatted values using the same logic as the grid with proper error handling
				const society = this.societies.find(
					(s) => s.id === parseInt(netlink.society_id)
				);
				const societyName = society ? society.name : this.societyName;

				const mission = this.missions.find(
					(m) => m.id === parseInt(netlink.mission_id)
				);
				const missionName = mission ? mission.perform : "";

				const provider = this.providers.find(
					(p) => p.id === parseInt(netlink.provider_id)
				);
				const providerName = provider ? provider.society : "";

				const linkType = this.linkTypes.find(
					(t) => t.id === parseInt(netlink.link_type)
				);
				const linkTypeName = linkType ? linkType.name : "";

				const thema = this.themas.find(
					(t) => t.id === parseInt(netlink.thema_id || 0)
				);
				const themaName = thema ? thema.name : "";

				const anchorType = this.anchorTypes.find(
					(t) => t.type_value === (netlink.anchor_type || 0)
				);
				const anchorTypeName = anchorType ? anchorType.type_text : "";

				const status = this.netlinkStatus.find(
					(s) => s.status_value == netlink.status
				);
				const statusText = status ? status.status_text : "";

				const renewDuration = this.renewDurations.find(
					(d) => d.id === Number(netlink.renew_duration)
				);
				const renewLabel = renewDuration ? renewDuration.label : "";

				// Get consultant name from contracts store using contract_id
				const contracts = store.state.contracts || [];
				const contract = contracts.find(
					(c) => c.id === parseInt(netlink.contract_id)
				);
				const consultantName =
					contract && contract.manager_name ? contract.manager_name : "";

				// Calculate sale price and margin
				const salePrice =
					netlink.calculated_price ||
					this.calculateSalePrice(netlink.price, netlink.mission_id);
				const marginPercentage = this.calculateMarginPercentage(
					netlink.price,
					salePrice
				);

				return {
					ID: netlink.id || "",
					Statut: statusText,
					"En ligne": netlink.additional_online_status || "",
					"Etat du lien": netlink.additional_link_type || "",
					Client: societyName,
					"N° Contrat": netlink.contract_id || this.contractId,
					Prestation: missionName,
					Consultant: consultantName,
					Période:
						this.formatPeriod(netlink.period_date) || netlink.period_date || "",
					"URL Backlinks": netlink.url_bought || "",
					"URL Landing": netlink.landing_page || "",
					Prestataire: providerName,
					"Type de lien": linkTypeName,
					Thématique: themaName,
					"Type d'ancre": anchorTypeName,
					Ancre: netlink.anchor || "",
					International: netlink.is_international ? "Oui" : "Non",
					Renew: renewLabel,
					"Date de renew": this.formatTimeStamp(netlink.renew_date),
					// Facturable: netlink.is_billable ? "Oui" : "Non",
					"Prix d'achat HT": netlink.price ? `${netlink.price} €` : "",
					"Prix de vente HT": salePrice ? `${salePrice} €` : "",
					"Taux Marge": marginPercentage,
					"Date création": this.formatTimeStamp(netlink.creation_date),
				};
			});
		},

		// 🔹 NEW: Generate export filename
		generateExportFilename() {
			const now = new Date();
			const dateStr = now.toISOString().split("T")[0]; // YYYY-MM-DD
			const timeStr = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // HH-MM-SS

			// Add contract info to filename
			let filterInfo = `_contrat-${this.contractId}`;
			if (this.societyName) {
				filterInfo += `_${this.societyName.replace(/[^a-zA-Z0-9]/g, "-")}`;
			}

			// Add current filter info to filename if any filters are applied
			if (this.queries.status) filterInfo += `_statut-${this.queries.status}`;
			if (this.queries.mission_id)
				filterInfo += `_prestation-${this.queries.mission_id}`;
			if (this.queries.provider_id)
				filterInfo += `_prestataire-${this.queries.provider_id}`;

			// Period range in filename
			if (this.queries.period_date && this.queries.end_period_date) {
				filterInfo += `_periode-${this.queries.period_date.replace(
					"/",
					"-"
				)}_au_${this.queries.end_period_date.replace("/", "-")}`;
			} else if (this.queries.period_date) {
				filterInfo += `_periode-${this.queries.period_date.replace("/", "-")}`;
			}

			return `netlinks_export${filterInfo}_${dateStr}_${timeStr}.csv`;
		},

		// 🔹 NEW: Download CSV file
		downloadCSV(data, filename) {
			if (!data || data.length === 0) {
				throw new Error("No data to export");
			}

			// Get headers from first row
			const headers = Object.keys(data[0]);

			// Create CSV content
			const csvContent = [
				// Headers row
				headers.map((header) => `"${header}"`).join(","),
				// Data rows
				...data.map((row) =>
					headers
						.map((header) => {
							const value = row[header] || "";
							// Escape quotes and wrap in quotes
							return `"${String(value).replace(/"/g, '""')}"`;
						})
						.join(",")
				),
			].join("\n");

			// Create blob and download
			const blob = new Blob(["\ufeff" + csvContent], {
				type: "text/csv;charset=utf-8;",
			}); // \ufeff is BOM for UTF-8

			const link = document.createElement("a");
			const url = URL.createObjectURL(blob);

			link.setAttribute("href", url);
			link.setAttribute("download", filename);
			link.style.visibility = "hidden";

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			// Clean up
			URL.revokeObjectURL(url);
		},

		dateClear() {
			// Clear the month picker input
			this.queries.period_date = "";
			this.datePickerKey++; // Force month picker to reset
			this.applyFilters();
		},
		// ✅ NEW: Helper methods for status-based editing
		isRowEditable(params) {
			// Always allow editing for new rows
			if (params.data && params.data._isNew) {
				return true;
			}

			// Super Administrateur (user_type 191) can edit all rows
			if (this.activeUser && this.activeUser.type == 9) {
				return true;
			}

			// Check status: 0 = Actif (not editable for non-super admin), 1 = En attente (editable)
			if (params.data && params.data.status !== undefined) {
				return params.data.status !== 0; // Not editable if status is 0 (Actif)
			}

			// Default to editable if status is not set
			return true;
		},

		getNonEditableCellStyle(params) {
			let style = {};

			// If row is not editable due to status, add visual indication
			if (params.data && !this.isRowEditable(params)) {
				style.backgroundColor = "#f5f5f5";
				style.color = "#999";
				style.cursor = "not-allowed";
				style.opacity = "0.7";
			}

			// Add yellow border for duplicate rows
			if (params.data && params.data._isDuplicate) {
				style.border = "2px solid #FFC107";
				style.backgroundColor = "#FFF9E6";
			}

			return style;
		},

		// ✅ NOUVEAU : Méthodes de filtrage
		applyFilters() {
			// Clear previous timeout to debounce the filter
			if (this.filterTimeout) {
				clearTimeout(this.filterTimeout);
			}

			// Show pending indicator
			this.isFilterPending = true;

			// Setup debounce for filter to avoid too many API calls
			this.filterTimeout = setTimeout(() => {
				this.isFilterPending = false;
				this.fetchDatas(); // Fetch data from API with new filters
			}, 1500);
		},

		resetFilters() {
			// Reset all query filters to default
			this.queries = {
				status: [], // Reset to empty array for multiple selection
				mission_id: "",
				period_date: "",
				end_period_date: "", // Reset end period
				provider_id: "",
				link_type: "",
				url_link: "", // Reset URL filter
				additional_link_type: [], // Reset additional link type filter
			};

			// Reset month pickers if using them
			if (this.useGestionPeriodPicker) {
				this.datePickerKey++;
				this.endDatePickerKey++;
			}

			// Force refresh du tableau
			this.tableKey++;
		},

		// ✅ NOUVEAU : Gestion du month picker (Start Period)
		onPeriodDateChange(date) {
			// Validate that date object exists and has the expected structure
			if (!date || !date.from) {
				console.error(
					"Invalid date object received in onPeriodDateChange:",
					date
				);
				return;
			}

			// Convert month picker date to MM/YYYY format
			let sendDate = moment(date.from).format("MM/YYYY");
			this.queries.period_date = sendDate;

			console.log("Start period date changed to:", sendDate);

			// ✅ NOUVEAU : Clear end period if it's now before the start period
			if (this.queries.end_period_date) {
				const [startMonth, startYear] = sendDate.split("/").map(Number);
				const [endMonth, endYear] = this.queries.end_period_date
					.split("/")
					.map(Number);

				const startNum = startYear * 100 + startMonth;
				const endNum = endYear * 100 + endMonth;

				if (endNum < startNum) {
					this.queries.end_period_date = "";
					this.endThisMonth = null;
					this.endThisYear = null;
					this.endDatePickerKey++;
					console.log(
						"End period cleared because it was before the new start period"
					);
				}
			}

			// Apply filters with the new date
			this.applyFilters();
		},

		// ✅ NOUVEAU : Clear period date (Start Period)
		clearPeriodDate() {
			this.queries.period_date = "";
			this.datePickerKey++; // Force month picker to reset
			this.applyFilters();
		},

		// ✅ NOUVEAU : Gestion du month picker (End Period)
		onEndPeriodDateChange(date) {
			// Validate that date object exists and has the expected structure
			if (!date || !date.from) {
				console.error(
					"Invalid date object received in onEndPeriodDateChange:",
					date
				);
				return;
			}

			// Convert month picker date to MM/YYYY format
			let sendDate = moment(date.from).format("MM/YYYY");
			this.queries.end_period_date = sendDate;

			console.log("End period date changed to:", sendDate);

			// Apply filters with the new date
			this.applyFilters();
		},

		// ✅ NOUVEAU : Clear end period date
		clearEndPeriodDate() {
			this.queries.end_period_date = "";
			this.endThisMonth = null;
			this.endThisYear = null;
			this.endDatePickerKey++; // Force month picker to reset
			this.applyFilters();
		},

		// ✅ UPDATED: fetchDatas method to preserve sell_price from database
		async fetchDatas() {
			try {
				this.isLoading = true;

				// Load all data in parallel
				const [
					netlinksResult,
					providersResult,
					linkTypesResult,
					themasResult,
					anchorTypesResult,
					missionsResult,
					contractResult,
				] = await Promise.all([
					Netlink.getNetlinksForContract(this.contractId),
					Provider.getNetlinkProvider(),
					Netlink.getTypes(),
					Netlink.getThemas(),
					Netlink.getNetlinkAnchorTypes(),
					Mission.getMissionsForContractAsync(this.contractId),
					Contract.getById(this.contractId),
				]);

				// ✅ NEW: Process netlinks to preserve sell_price from database
				this.netlinks = netlinksResult.map((netlink) => {
					// If netlink has sell_price from database, use it as calculated_price
					if (netlink.sell_price !== undefined && netlink.sell_price !== null) {
						netlink.calculated_price = netlink.sell_price;
						// Mark that this price came from database (not calculated)
						netlink.isCalculatedPriceFromDB = true;
					}
					return netlink;
				});

				// Add empty option for providers (similar to themas)
				this.providers = [{ id: null, society: "" }].concat(providersResult);

				// Add empty option for link types (similar to themas) - fix property name inconsistency
				this.linkTypes = [{ id: null, name: "" }].concat(linkTypesResult);

				// Themas already has empty option correctly
				this.themas = [{ id: null, name: "" }].concat(themasResult);

				this.anchorTypes = [{ type_value: null, type_text: "" }].concat(
					anchorTypesResult
				);
				this.filterOptionAnchorTypes = anchorTypesResult;
				this.missions = missionsResult.filter((ele) => {
					return ele.sub_category == 7 || ele.products_id == 136;
				});

				// Store contract data for consultant name
				this.contract = contractResult;

				// Log data for debugging
				console.log("Data loaded:", {
					netlinks: this.netlinks.length,
					providers: this.providers.length,
					linkTypes: this.linkTypes.length,
					anchorTypes: this.anchorTypes.length,
				});

				// Update original netlinks for change tracking
				this.originalNetlinks = {};
				this.netlinks.forEach((netlink) => {
					if (netlink.id) {
						this.originalNetlinks[netlink.id] = JSON.parse(
							JSON.stringify(netlink)
						);
					}
				});

				// Reset tracking
				this.resetChangeTracking();

				// Ensure we have real data before rendering
				this.assignColumns();
				this.isLoading = false;
				this.tableKey++; // Force grid refresh
			} catch (error) {
				console.error("Error loading data:", error);
				this.isLoading = false;
			}
		},
		async getPeriodList() {
			// Super admin can access 12 months, regular users get 3 months
			const monthsBack = this.activeUser && this.activeUser.type == 9 ? 12 : 3;
			this.periodList = await this.getPeriodDateList(monthsBack);
		},
		resetChangeTracking() {
			this.modifiedRows = new Set();
			this.newRows = new Set();
			this.deletedRows = new Set();
		},
		assignColumns() {
			this.columnDefs = [
				{
					headerCheckboxSelection: true,
					checkboxSelection: true,
					headerName: "",
					field: "checkbox",
					width: 50,
					pinned: "left",
					sortable: false,
					filter: false,
					resizable: false,
					suppressMenu: true,
				},
				{
					field: "status",
					headerName: "Statut",
					headerTooltip: "Statut actuel du backlink",
					editable: true, // Status field should always be editable to allow status changes
					pinned: "left",
					cellEditor: "agSelectCellEditor",
					width: 120,
					cellEditorParams: (params) => {
						const value = params.value ? Number(params.value) : 0;
						return {
							values: this.netlinkStatus.map((s) => Number(s.status_value)),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (params.value === undefined || params.value === null) return "";
						const status = this.netlinkStatus.find(
							(s) => s.status_value == Number(params.value)
						);
						return status && status.status_text
							? status.status_text
							: params.value;
					},
					cellStyle: (params) => {
						const colorConfig = this.getNetlinkStatusColor(params.value);

						if (colorConfig) {
							return {
								backgroundColor: colorConfig,
								textAlign: "center",
								color: "#ffffff !important",
								transition: "all 0.2s ease",
							};
						}

						return null;
					},
				},
				{
					field: "additional_online_status",
					headerName: "En ligne",
					headerTooltip: "Statut de mise en ligne du backlink",
					editable: (params) => false,
					width: 100,
					cellRenderer: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}
						const status = Number(params.value);
						let color = "";
						let tooltipText = "";
						if (status === 1) {
							color = "#28C76F"; // success green
							tooltipText = "Lien trouvé";
						} else if (status === 4) {
							color = "#FF9F43"; // warning orange
							tooltipText = "Lien vers un autre URL du même domaine";
						} else if (status === 2) {
							color = "#EA5455"; // danger red

							tooltipText = "Lien supprimé (page lue, lien absent)";
						} else if (status === 3) {
							const statusCode =
								params.data && params.data.additional_status_code;
							color = "#979797FF"; // danger red
							tooltipText = "Page illisible, non vérifié"
								+ (statusCode ? " (HTTP " + statusCode + ")" : "");
						}
						const checkedAt = params.data && params.data.additional_updated_date;
						if (checkedAt) {
							tooltipText = tooltipText + " : " + String(checkedAt).split("T")[0];
						}
						return `<div title="${tooltipText}" style="display: flex; align-items: center; justify-content: center; height: 100%; cursor: help;"><svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="6" fill="${color}"/></svg></div>`;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "additional_link_type",
					headerName: "Etat du lien",
					headerTooltip: "Etat du liens",
					editable: (params) => false,
					width: 120,
					cellRenderer: (params) => {
						if (!params.value) return "";
						const value = params.value.toLowerCase();
						let color = "";

						if (value === "dofollow") {
							color = "#28C76F"; // green
						} else if (value === "nofollow") {
							color = "#EA5455"; // red
						} else {
							color = "#B8C2CC"; // gray
						}

						const label = value.charAt(0).toUpperCase() + value.slice(1);
						return `<span style="color: ${color}; font-weight: 500;">${label}</span>`;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "mission_id",
					headerName: "Prestation",
					editable: (params) => this.isRowEditable(params),
					width: 200,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const contractId = params.data.contract_id;
						let missions = [];
						// Filter missions by contract_id AND status (1 or 3)
						if (params.data._isNew) {
							// For new rows, show all missions
							missions = this.missions.filter(
								(m) => m.contract_id === parseInt(contractId)
							);
							missions = missions.sort((a, b) =>
								a.status === 1 && b.status !== 1
									? -1
									: a.status !== 1 && b.status === 1
									? 1
									: a.id - b.id
							);
						} else {
							// For existing rows, show missions based on contract_id and status
							missions = this.missions.filter(
								(m) => m.contract_id === parseInt(contractId)
							);
						}

						return {
							values: missions.map((m) => Number(m.id)),
						};
					},
					valueFormatter: (params) => {
						if (!params.value) return "";
						const missionObj = this.missions.find(
							(m) => m.id === Number(params.value)
						);
						return missionObj && missionObj.perform
							? `${params.value} - ${missionObj.perform}` +
									" - " +
									this.getContractStatus(missionObj.status)
							: params.value;
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
				},
				{
					field: "period_date",
					headerName: "Période",
					headerTooltip: "Période de création du backlink (mois/année)",
					editable: (params) => this.isRowEditable(params),
					width: 90,
					cellEditor: "agSelectCellEditor",
					comparator: (valueA, valueB) => {
						// Custom comparator for MM/YYYY date format
						if (!valueA && !valueB) return 0;
						if (!valueA) return -1;
						if (!valueB) return 1;

						// Find the corresponding date names from periodList
						const optionA = this.periodList.find((o) => o.date_value == valueA);
						const optionB = this.periodList.find((o) => o.date_value == valueB);

						// Get the date strings (MM/YYYY format)
						const dateStrA = optionA && optionA.name ? optionA.name : valueA;
						const dateStrB = optionB && optionB.name ? optionB.name : valueB;

						// Parse MM/YYYY format
						const parseDate = (dateStr) => {
							const parts = dateStr.split("/");
							if (parts.length === 2) {
								const month = parseInt(parts[0], 10);
								const year = parseInt(parts[1], 10);
								// Create comparable number: YYYYMM
								return year * 100 + month;
							}
							return 0;
						};

						const dateA = parseDate(dateStrA);
						const dateB = parseDate(dateStrB);

						return dateA - dateB;
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					cellEditorParams: (params) => {
						// Convert value to string for matching
						const value =
							params.value !== undefined ? params.value.toString() : "1";

						return {
							values: this.periodList.map((o) => o.date_value.toString()),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (params.value === undefined || params.value === null) return "";
						const option = this.periodList.find(
							(o) => o.date_value == params.value
						);
						return option && option.name ? option.name : params.value;
					},
				},
				{
					field: "url_bought",
					headerName: "Url backlinks",
					headerTooltip: "URL du site où le backlink a été acheté",
					editable: (params) => this.isRowEditable(params),
					width: 250,
					cellEditor: "agTextCellEditor",
					cellEditorParams: {
						maxLength: 200,
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					cellRenderer: (params) => {
						if (!params.value) return "";

						// Ensure the URL has a protocol
						let url = params.value;
						if (url && !url.match(/^https?:\/\//)) {
							url = "https://" + url;
						}

						return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${params.value}</a>`;
					},
					valueFormatter: (params) => params.value || "",
					tooltip: (params) => {
						if (!params.value) return null;

						return `${params.value}`;
					},
				},
				{
					field: "landing_page",
					headerName: "Url landing",
					headerTooltip: "URL de la page de destination du backlink",
					editable: (params) => this.isRowEditable(params),
					width: 250,
					cellEditor: "agTextCellEditor",
					cellEditorParams: {
						maxLength: 200,
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					cellRenderer: (params) => {
						if (!params.value) return "";

						// Ensure the URL has a protocol
						let url = params.value;
						if (url && !url.match(/^https?:\/\//)) {
							url = "https://" + url;
						}

						return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${params.value}</a>`;
					},
					valueFormatter: (params) => params.value || "",
					tooltip: (params) => {
						if (!params.value) return null;

						return `${params.value}`;
					},
				},
				{
					field: "provider_id",
					headerName: "Prestataire",
					headerTooltip: "Prestataire ou fournisseur du backlink",
					editable: (params) => {
						// First check if row is editable based on status
						if (!this.isRowEditable(params)) {
							return false;
						}
						// Then check if provider is editable based on period
						return this.isProviderEditable(params.data);
					},
					width: 120,
					cellEditor: "agSelectCellEditor",
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						// Red background for empty required fields in new rows
						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}

						// Gray background for non-editable cells (period > 3 months)
						if (!this.isProviderEditable(params.data)) {
							style.backgroundColor = "#f5f5f5";
							style.color = "#999";
							style.cursor = "not-allowed";
						}

						return style;
					},
					cellEditorParams: (params) => {
						const value = params.value != null ? Number(params.value) : null;
						return {
							values: this.providers.map((p) => p.id),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}

						const provider = this.providers.find(
							(p) => p.id === Number(params.value)
						);
						return provider && provider.society ? provider.society : "";
					},
					tooltip: (params) => {
						if (!this.isRowEditable(params)) {
							return "Édition bloquée : statut actif";
						}
						if (!this.isProviderEditable(params.data)) {
							return "Édition bloquée : période supérieure à 3 mois";
						}
						return null;
					},
				},
				// Commented out is_billable column for now
				// {
				// 	field: "is_billable",
				// 	headerName: "Facturable",
				// 	headerTooltip: "Indique si le backlink est facturable au client",
				// 	editable: (params) => this.isRowEditable(params),
				// 	width: 120,
				// 	cellEditor: "agSelectCellEditor",
				// 	cellEditorParams: (params) => {
				// 		const value = params.value !== undefined ? Number(params.value) : 0;
				// 		return {
				// 			values: this.facturableOptions.map((o) => Number(o.id)),
				// 			defaultOption: value,
				// 		};
				// 	},
				// 	valueFormatter: (params) => {
				// 		if (params.value === undefined || params.value === null)
				// 			return "Non renseigné";
				// 		const option = this.facturableOptions.find(
				// 			(o) => o.id === Number(params.value)
				// 		);
				// 		return option && option.label ? option.label : params.value;
				// 	},
				// 	cellStyle: (params) => this.getNonEditableCellStyle(params),
				// },
				{
					field: "price",
					headerName: "Prix d'achat HT",
					headerTooltip: "Prix d'achat du backlink hors taxes",
					editable: (params) => this.isRowEditable(params),
					width: 150,
					cellEditor: "agTextCellEditor",
					valueFormatter: (params) => {
						if (params.value !== null && params.value !== undefined) {
							return params.value + " €";
						}
						return "";
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
				},
				{
					field: "calculated_price",
					headerName: "Prix de vente HT",
					headerTooltip: "Prix de vente calculé du backlink hors taxes",
					editable: (params) => this.isRowEditable(params),
					width: 150,
					cellEditor: "agTextCellEditor",
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
					// ✅ UPDATED: valueGetter to preserve database values
					valueGetter: (params) => {
						if (!params.data) return null;

						// ✅ NEW: If this is from database and has calculated_price, use it
						if (
							params.data.calculated_price !== undefined &&
							params.data.calculated_price !== null
						) {
							return params.data.calculated_price;
						}

						// ✅ NEW: For new rows or when price changes, calculate it
						if (!params.data.price) return null;
						return this.calculateSalePrice(
							params.data.price,
							params.data.mission_id
						);
					},
					valueSetter: (params) => {
						if (params.newValue !== undefined && params.newValue !== null) {
							params.data.calculated_price = params.newValue;
							// ✅ NEW: Mark as manually edited (not from database)
							params.data.isCalculatedPriceFromDB = false;
							params.data.isCalculatedPriceManual = true;
							return true;
						}
						return false;
					},
					valueFormatter: (params) => {
						if (params.value !== null && params.value !== undefined) {
							return params.value + " €";
						}
						return "";
					},
				},
				{
					field: "margin",
					headerName: "Tx Marge",
					headerTooltip:
						"Taux de marge calculé entre le prix d'achat et de vente",
					width: 100,
					editable: false,
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
					// ✅ UPDATED: Pass mission_id to calculateSalePrice
					valueGetter: (params) => {
						if (!params.data || !params.data.price) return "";

						// If calculated_price is explicitly 0 or null, margin should be 0%
						if (
							params.data.calculated_price === 0 ||
							params.data.calculated_price === null ||
							params.data.calculated_price === ""
						) {
							return "0%";
						}

						const salePrice =
							params.data.calculated_price ||
							this.calculateSalePrice(
								params.data.price,
								params.data.mission_id
							);
						return this.calculateMarginPercentage(params.data.price, salePrice);
					},
					// Custom comparator for sorting by numeric margin value
					comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
						// Extract numeric values from margin strings
						const getNumericMargin = (value) => {
							if (!value || value === "N/A") return -999999; // Put N/A at the bottom
							// Remove % sign and parse as float
							return parseFloat(value.replace("%", ""));
						};

						const numA = getNumericMargin(valueA);
						const numB = getNumericMargin(valueB);

						if (numA === numB) return 0;
						return numA > numB ? 1 : -1;
					},
				},

				{
					field: "link_type",
					headerName: "Type de lien",
					headerTooltip:
						"Type ou catégorie du backlink (follow, nofollow, etc.)",
					editable: (params) => this.isRowEditable(params),
					width: 150,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value = params.value ? Number(params.value) : null;
						return {
							values: this.linkTypes.map((t) => t.id), // Include null for empty option
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}

						const type = this.linkTypes.find(
							(t) => t.id === Number(params.value)
						);
						return type && type.name ? type.name : "";
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
				},

				{
					field: "thema_id",
					headerName: "Thematique",
					headerTooltip: "Thématique ou secteur d'activité du backlink",
					width: 120,
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						// Convert value to string for matching
						const value = params.value != null ? Number(params.value) : 1;

						return {
							values: this.themas.map((t) => t.id), // ✅ make sure these are strings
							defaultOption: value, // ✅ also a string
						};
					},
					valueFormatter: (params) => {
						// Si la valeur est null, undefined ou vide, afficher une chaîne vide
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}

						const type = this.themas.find((t) => t.id == params.value);
						return type && type.name ? type.name : "";
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "anchor_type",
					headerName: "Type d'ancre",
					headerTooltip:
						"Type d'ancre utilisée pour le backlink (exact match, brandé, etc.)",
					width: 150,
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value = params.value ? Number(params.value) : 0;
						return {
							values: this.anchorTypes.map((t) => Number(t.id)),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						// Si la valeur est null, undefined ou vide, afficher une chaîne vide
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}

						const type = this.anchorTypes.find(
							(t) => t.type_value == params.value
						);
						return type && type.type_text ? type.type_text : "";
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "anchor",
					headerName: "Ancre",
					headerTooltip: "Texte d'ancrage du backlink",
					width: 100,
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agTextCellEditor",
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},

				{
					field: "is_international",
					headerName: "International",
					headerTooltip:
						"Indique si le backlink provient d'un site international",
					editable: (params) => this.isRowEditable(params),
					width: 120,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value = params.value !== undefined ? Number(params.value) : 0;
						return {
							values: this.internationalOptions.map((o) => Number(o.id)),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (params.value === undefined || params.value === null)
							return "Non renseigné";
						const option = this.internationalOptions.find(
							(o) => o.id === Number(params.value)
						);
						return option && option.label ? option.label : params.value;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},

				{
					field: "renew_duration",
					headerName: "Renew",
					headerTooltip: "Durée de renouvellement du backlink en mois",
					editable: (params) => this.isRowEditable(params),
					width: 100,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value = params.value ? Number(params.value) : 0;
						return {
							values: this.renewDurations.map((d) => Number(d.id)),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (!params.value && params.value !== 0) return 0;
						const duration = this.renewDurations.find(
							(d) => d.id === Number(params.value)
						);
						return duration && duration.label ? duration.label : params.value;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "renew_date",
					headerName: "Date de renew",
					headerTooltip: "Date prévue de renouvellement du backlink",
					editable: false,
					width: 130,
					valueFormatter: (params) => {
						return this.formatTimeStamp(params.value);
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
				},

				{
					field: "creation_date",
					headerName: "Création",
					headerTooltip: "Date de création du backlink dans le système",
					editable: false,
					width: 100,
					cellEditor: "agDateCellEditor",
					cellEditorParams: {
						min: "2000-01-01",
						max: "2030-12-31",
					},
					valueFormatter: (params) => {
						return this.formatTimeStamp(params.value);
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data.mozDA",
					headerName: "DA",
					headerTooltip: "Domain Authority (Moz)",
					editable: false,
					width: 70,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value = parsed && parsed.data && parsed.data.mozDA;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data.majesticCF",
					headerName: "CF",
					headerTooltip: "Citation Flow (Majestic)",
					editable: false,
					width: 70,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value = parsed && parsed.data && parsed.data.majesticCF;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data.majesticTF",
					headerName: "TF",
					headerTooltip: "Trust Flow (Majestic)",
					editable: false,
					width: 70,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value = parsed && parsed.data && parsed.data.majesticTF;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data.majesticRefDomains",
					headerName: "RD",
					headerTooltip: "Referring Domains (Majestic)",
					editable: false,
					width: 120,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value =
								parsed && parsed.data && parsed.data.majesticRefDomains;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					headerName: "Actions",
					headerTooltip:
						"Actions disponibles pour ce backlink (supprimer, modifier, etc.)",
					field: "actions",
					editable: false,
					sortable: false,
					width: 150,
					cellRenderer: (params) => {
						const eDiv = document.createElement("div");
						eDiv.classList.add("action-buttons");

						// For new rows, add a clear button with vs-button styling
						if (params.data._isNew) {
							const clearButton = document.createElement("button");
							clearButton.className = "";
							clearButton.innerHTML = "Annuler";
							clearButton.style.backgroundColor = "#f44336"; // Red background
							clearButton.style.color = "#ffffff"; // White text
							clearButton.style.border = "none";
							clearButton.style.padding = "5px 10px";
							clearButton.style.marginLeft = "5px";
							clearButton.style.borderRadius = "4px";
							clearButton.style.cursor = "pointer";
							clearButton.style.fontSize = "12px";
							clearButton.addEventListener("click", () =>
								this.clearNewRow(params.data, params.rowIndex)
							);
							eDiv.appendChild(clearButton);
						} else {
							// // Delete button with vs-button styling
							const deleteButton = document.createElement("button");
							deleteButton.className = "pd-5";
							deleteButton.style.backgroundColor = "#f44336"; // Red background
							deleteButton.style.color = "#ffffff"; // White text
							deleteButton.style.border = "none";
							deleteButton.style.padding = "5px 10px";
							deleteButton.style.marginLeft = "5px";
							deleteButton.style.borderRadius = "4px";
							deleteButton.style.cursor = "pointer";
							deleteButton.style.fontSize = "12px";
							deleteButton.innerHTML = "Supprimer";

							// Disable delete button if status is Actif (0) - except for Super Administrateur
							if (
								params.data.status === 0 &&
								(!this.activeUser || this.activeUser.user_type != 191)
							) {
								deleteButton.disabled = true;
								deleteButton.style.backgroundColor = "#cccccc";
								deleteButton.style.cursor = "not-allowed";
								deleteButton.title = "Suppression bloquée : statut actif";
							} else {
								deleteButton.onmouseover = function () {
									this.style.backgroundColor = "#d32f2f"; // Darker red on hover
								};
								deleteButton.onmouseout = function () {
									this.style.backgroundColor = "#f44336"; // Back to original red
								};
								deleteButton.addEventListener("click", () =>
									this.deleteNetlink(params.data)
								);
							}

							eDiv.appendChild(deleteButton);
						}

						return eDiv;
					},
				},
			];
		},
		// ✅ UPDATED: createNewRow method
		createNewRow() {
			const newRow = {
				contract_id: this.contractId,
				society_id: this.societyId, // Add society_id from prop
				society_name: this.societyName,
				mission_id: null,
				url_bought: "",
				landing_page: "",
				provider_id: null,
				thema_id: null,
				anchor_type: null,
				anchor: "",
				period_date: moment().format("MM/YYYY"),
				link_type: null,
				renew_duration: 0,
				renew_date: null,
				status: 1, // En attente par défaut (editable)
				is_billable: 0,
				is_international: 0,
				price: null,
				calculated_price: null,
				// ✅ NEW: Mark as new row (not from database)
				isCalculatedPriceFromDB: false,
				creation_date: new Date().toISOString().split("T")[0],
				_isNew: true,
				_isDuplicate: false,
			};

			return newRow;
		},
		refreshRequiredFieldStyles(rowIndex) {
			if (this.gridApi) {
				this.gridApi.refreshCells({
					rowNodes: [this.gridApi.getDisplayedRowAtIndex(rowIndex)],
					columns: [
						"mission_id",
						"url_bought",
						"landing_page",
						"provider_id",
						"link_type",
						"price",
					],
					force: true,
				});
			}
		},
		formatPeriod(periodString) {
			if (!periodString) return "";

			try {
				const [month, year] = periodString.split("/");
				const monthNames = [
					"Janvier",
					"Février",
					"Mars",
					"Avril",
					"Mai",
					"Juin",
					"Juillet",
					"Août",
					"Septembre",
					"Octobre",
					"Novembre",
					"Décembre",
				];

				const monthIndex = parseInt(month, 10) - 1;
				if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
					return periodString;
				}
				return `${monthNames[monthIndex]} ${year}`;
			} catch (e) {
				console.error("Erreur de formatage de période:", e);
				return periodString;
			}
		},
		formatTimeStamp(dateString) {
			if (!dateString) return "";

			try {
				const date = new Date(dateString);

				// Vérifier si la date est valide
				if (isNaN(date.getTime())) return "";

				// Format: DD/MM/YYYY
				return date.toLocaleDateString("fr-FR", {
					day: "2-digit",
					month: "2-digit",
					year: "2-digit",
				});
			} catch (e) {
				console.error("Erreur de formatage de date:", e);
				return "";
			}
		},
		getNetlinksForContract(contractId) {
			return Netlink.getNetlinksForContract(contractId)
				.then((res) => {
					this.netlinks = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur est survenue lors de la récupération des netlinks",
						iconPack: "feather",
						icon: "alert-circle",
						color: "danger",
					});
					return [];
				});
		},
		getNetlinkStatus() {
			return Netlink.getNetlinkStatus()
				.then((res) => {
					this.netlinkStatus = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getNetlinkAnchorTypes() {
			return Netlink.getNetlinkAnchorTypes()
				.then((res) => {
					this.anchorTypes = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getProviders() {
			return Provider.getAll()
				.then((res) => {
					this.providers = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getNetlinkThemas() {
			return Netlink.getThemas()
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getNetlinkTypes() {
			return Netlink.getTypes()
				.then((res) => {
					this.linkTypes = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		async onBtAddRow() {
			// Check if there are existing unsaved new rows that need to be saved first
			if (this.newRows.size > 0) {
				// Get all new rows that need to be saved
				const unsavedNewRows = Array.from(this.newRows)
					.map((index) => ({
						index,
						netlink: this.netlinks[index],
					}))
					.filter((item) => item.netlink && item.netlink._isNew);

				// Process each unsaved row
				for (const { netlink, index } of unsavedNewRows) {
					// Check if the row has minimum required fields
					if (this.isValidNetlink(netlink)) {
						// Check for duplicates with existing netlinks
						const isDuplicate = this.checkNetlinkDuplicate(netlink);

						if (isDuplicate) {
							// Mark as duplicate and show error
							this.$set(this.netlinks[index], "_isDuplicate", true);

							// Force grid refresh to show yellow styling
							if (this.gridApi) {
								this.gridApi.refreshCells({ force: true });
							}

							this.$vs.notify({
								title: "Erreur: Doublon détecté",
								text: `Un netlink actif existe déjà: ${netlink.url_bought} -> ${netlink.landing_page}`,
								iconPack: "feather",
								icon: "x-circle",
								color: "danger",
								time: 5000,
							});
							return; // Don't add new row if duplicate exists
						}

						// Try to save the netlink
						try {
							const netlinkToSave = this.prepareNetlinkForSave({ ...netlink });
							delete netlinkToSave._isNew;
							delete netlinkToSave._isDuplicate;

							const res = await Netlink.createNetlink(netlinkToSave);

							// Update the netlink with the saved ID
							this.$set(this.netlinks[index], "id", res.id);
							this.$set(this.netlinks[index], "_isNew", false);
							this.$set(this.netlinks[index], "_isDuplicate", false);

							// Remove from newRows tracking
							this.newRows.delete(index);

							// Update original data tracking
							if (res.id) {
								this.originalNetlinks[res.id] = JSON.parse(
									JSON.stringify(this.netlinks[index])
								);
							}

							this.$vs.notify({
								title: "Succès",
								text: "Netlink enregistré avec succès",
								iconPack: "feather",
								icon: "check-circle",
								color: "success",
								time: 2000,
							});
						} catch (err) {
							console.error("Save error:", err);

							// Check if it's a duplicate error from backend
							if (err.response && err.response.status === 409) {
								this.$set(this.netlinks[index], "_isDuplicate", true);
								this.$vs.notify({
									title: "Erreur: Doublon",
									text: "Ce netlink existe déjà dans la base de données",
									iconPack: "feather",
									icon: "alert-triangle",
									color: "danger",
									time: 5000,
								});
							} else {
								this.$vs.notify({
									title: "Erreur",
									text: `Impossible d'enregistrer le netlink: ${
										err.message || "Erreur inconnue"
									}`,
									iconPack: "feather",
									icon: "x-circle",
									color: "danger",
									time: 5000,
								});
							}
							return; // Don't add new row if save failed
						}
					} else {
						// Show what fields are missing
						const missingFields = [];
						if (!netlink.url_bought) missingFields.push("URL backlinks");
						if (!netlink.landing_page) missingFields.push("URL landing");
						if (!netlink.provider_id) missingFields.push("Prestataire");
						if (!netlink.mission_id) missingFields.push("Prestation");

						this.$vs.notify({
							title: "Erreur: Champs requis manquants",
							text: `Complétez les champs suivants: ${missingFields.join(
								", "
							)}`,
							iconPack: "feather",
							icon: "alert-circle",
							color: "danger",
							time: 4000,
						});
						return; // Don't add new row if current row is incomplete
					}
				}
			}

			// If we get here, either there were no unsaved rows or they were all saved successfully
			// Now add the new row
			const newRow = this.createNewRow();

			// Ajout des propriétés spécifiques au contrat
			newRow.contract_id = this.contractId;
			newRow.society_id = this.societyId;

			// Get current row data
			const currentRowData = [...this.netlinks];

			// Add the new row at the beginning
			currentRowData.unshift(newRow);

			// Shift existing tracked indices since we're adding at the beginning
			const shiftedNewRows = new Set();
			const shiftedModifiedRows = new Set();

			// Shift all existing indices by 1
			this.newRows.forEach((index) => {
				shiftedNewRows.add(index + 1);
			});
			this.modifiedRows.forEach((index) => {
				shiftedModifiedRows.add(index + 1);
			});

			// Update with shifted indices
			this.newRows = shiftedNewRows;
			this.modifiedRows = shiftedModifiedRows;

			// Mark the new row at index 0
			this.newRows.add(0);

			// Update the row data
			this.netlinks = currentRowData;
		},
		clearNewRow(netlink, rowIndex) {
			// Remove the new row from the grid
			if (rowIndex !== undefined) {
				this.netlinks.splice(rowIndex, 1);
				this.newRows.delete(rowIndex);
				this.tableKey++; // Force refresh

				this.$vs.notify({
					title: "Information",
					text: "Nouvelle ligne annulée",
					iconPack: "feather",
					icon: "info",
					color: "primary",
				});
			}
		},
		// ✅ UPDATED: calculateSalePrice now checks mission.products_id
		calculateSalePrice(purchasePrice, missionId = null) {
			if (!purchasePrice) return null;

			const pa =
				typeof purchasePrice === "string"
					? Number(purchasePrice)
					: purchasePrice;

			console.log(
				"Calculating sale price for PA:",
				pa,
				"Mission ID:",
				missionId
			);
			if (isNaN(pa)) return null;

			// Check if mission has is_no_marge flag set (handles 1, "1", true, "true")
			if (missionId) {
				const mission = this.missions.find((m) => m.id === Number(missionId));
				if (
					mission &&
					(mission.is_no_marge === true ||
						mission.is_no_marge === 1 ||
						mission.is_no_marge === "1" ||
						mission.is_no_marge === "true")
				) {
					console.log(
						"Mission with is_no_marge detected - keeping sell price same as purchase price",
						"Mission ID:",
						missionId,
						"is_no_marge value:",
						mission.is_no_marge
					);
					return pa; // Return the same price without any markup
				}
			}

			// Original logic for other missions
			let multiplier;

			if (pa < 250) {
				multiplier = 2; // 100% margin => gain = 1 × PA => PA + PA = 2PA
			} else if (pa >= 2000) {
				multiplier = 1.5; // 50% margin => gain = 0.5 × PA => 1.5PA
			} else {
				// Linear degressive margin from 2 (at 250€) to 1.5 (at 2000€)
				const slope = (2 - 1.5) / (250 - 2000); // negative slope
				multiplier = 2 + slope * (pa - 250);
			}

			return Math.round(pa * multiplier);
		},

		// ✅ UPDATED: calculateMarginPercentage handles 0% margin cases
		calculateMarginPercentage(pa, pv) {
			// If no purchase price, return N/A
			if (!pa || pa === 0) return "N/A";

			// If no sell price, margin is 0%
			if (!pv || pv === 0) return "0%";

			// If purchase price equals sale price (like for mission with products_id 105), margin is 0%
			if (pa === pv) return "0%";

			return Math.round(((pv - pa) / pa) * 100) + "%";
		},
		// ✅ UPDATED: onCellValueChanged method
		onCellValueChanged(event) {
			console.log(
				"onCellValueChanged: " + event.colDef.field + " = " + event.newValue
			);

			// Track the changed row
			if (event.data._isNew) {
				// This is a new row, already tracked in this.newRows
				if (this.gridApi) {
					this.gridApi.refreshCells({
						rowNodes: [event.node],
						columns: [event.colDef.field],
						force: true,
					});
				}
			} else {
				// Track as modified row by netlink ID (not rowIndex, which changes with filters)
				if (event.data.id) {
					this.modifiedRows.add(event.data.id);
				}
			}

			// Check for duplicates when key fields change
			if (
				["url_bought", "landing_page", "contract_id", "period_date"].includes(
					event.colDef.field
				)
			) {
				// Check and mark duplicate immediately
				this.checkAndMarkDuplicate(event.data, event.rowIndex);
			}

			// Check domain existence via API when url_bought changes
			if (event.colDef.field === "url_bought" && event.newValue) {
				this.checkDomainExists(event.newValue, event.data.society_id);
			}

			// Handle status changes
			if (event.colDef.field === "status") {
				this.handleStatusChange(event);
				return;
			}

			// ✅ UPDATED: Handle mission_id changes - always recalculate when mission changes
			if (event.colDef.field === "mission_id" && event.data.price) {
				const newCalculated = this.calculateSalePrice(
					event.data.price,
					event.newValue
				);
				event.data.calculated_price = newCalculated;
				event.data.isCalculatedPriceFromDB = false; // Mark as calculated, not from DB
				event.node.setDataValue("calculated_price", newCalculated);
				this.gridApi.refreshCells({
					rowNodes: [event.node],
					columns: ["calculated_price", "margin"],
					force: true,
				});
			}

			// Handle manual calculated_price changes
			if (event.colDef.field === "calculated_price") {
				// Mark as manually overridden
				event.data.isCalculatedPriceManual = true;
				event.data.isCalculatedPriceFromDB = false;

				// Recalculate margin
				this.gridApi.refreshCells({
					rowNodes: [event.node],
					columns: ["margin"],
					force: true,
				});
			}

			// ✅ UPDATED: Handle price changes - always recalculate sell_price and margin
			if (event.colDef.field === "price") {
				const newCalculated = this.calculateSalePrice(
					event.newValue,
					event.data.mission_id
				);
				event.data.calculated_price = newCalculated;
				event.data.isCalculatedPriceFromDB = false; // Mark as calculated, not from DB
				event.node.setDataValue("calculated_price", newCalculated);
				this.gridApi.refreshCells({
					rowNodes: [event.node],
					columns: ["calculated_price", "margin"],
					force: true,
				});
			}

			// Handle renewal date calculation when period date or renewal duration changes
			if (
				event.colDef.field === "renew_duration" ||
				event.colDef.field === "creation_date"
			) {
				// Only proceed if we have both values needed for calculation
				if (event.data.creation_date) {
					const renewDate = this.calculateRenewDate(
						event.data.creation_date,
						event.data.renew_duration
					);

					// Update the field directly
					event.data.renew_date = renewDate;

					// Manually tell ag-Grid the value changed
					event.node.setDataValue("renew_date", renewDate);
					console.log(
						"Renewal date updated:",
						event.data.creation_date,
						event.data.renew_duration,
						renewDate
					);

					// Refresh the renewal date cell
					this.gridApi.refreshCells({
						rowNodes: [event.node],
						columns: ["renew_date"],
						force: true,
					});
				}
			}
		},
		/**
		 * Check if provider field can be edited based on period date
		 * @param {Object} rowData - The row data
		 * @returns {boolean} - True if editable, false otherwise
		 */
		isProviderEditable(rowData) {
			// Always allow editing for new rows
			if (rowData._isNew) {
				return true;
			}

			// Super Administrateur can edit provider_id regardless of period
			if (this.activeUser && this.activeUser.type == 9) {
				return true;
			}
			// If no period_date, allow editing
			if (!rowData.period_date) {
				return true;
			}

			try {
				// Parse the period date (format: MM/YYYY)
				const periodParts = rowData.period_date.split("/");
				if (periodParts.length !== 2) {
					return true; // If format is invalid, allow editing
				}

				const month = parseInt(periodParts[0], 10) - 1; // Month is 0-indexed in Date
				const year = parseInt(periodParts[1], 10);

				// Create date object for the period (first day of the month)
				const periodDate = new Date(year, month, 1);
				const currentDate = new Date();

				// Calculate the difference in months
				const monthsDifference = this.getMonthsDifference(
					periodDate,
					currentDate
				);

				// Return false if period is more than 3 months old
				return monthsDifference <= 3;
			} catch (error) {
				console.error("Error parsing period date:", error);
				return true; // If error, allow editing as fallback
			}
		},

		/**
		 * Calculate the difference in months between two dates
		 * @param {Date} startDate - The start date
		 * @param {Date} endDate - The end date
		 * @returns {number} - Number of months difference
		 */
		getMonthsDifference(startDate, endDate) {
			const yearsDifference = endDate.getFullYear() - startDate.getFullYear();
			const monthsDifference = endDate.getMonth() - startDate.getMonth();
			return yearsDifference * 12 + monthsDifference;
		},
		onRowValueChanged(event) {
			const data = event.data;
			console.log("onRowValueChanged:", data);

			// Validate required fields
			const missingRequired = [];

			if (!data.mission_id) missingRequired.push("Prestation");
			if (!data.url_bought) missingRequired.push("URL backlinks");
			if (!data.landing_page) missingRequired.push("URL landing");
			if (!data.provider_id) missingRequired.push("Prestataire");
			if (!data.link_type && data.link_type !== 0)
				missingRequired.push("Type de lien");
			if (!data.price && data.price !== 0)
				missingRequired.push("Prix d'achat HT");

			if (missingRequired.length > 0) {
				this.$vs.notify({
					title: "Champs obligatoires",
					text: `Les champs suivants sont obligatoires: ${missingRequired.join(
						", "
					)}`,
					iconPack: "feather",
					icon: "alert-circle",
					color: "warning",
				});
				return;
			}
		},
		// ✅ UPDATED: prepareNetlinkForSave method
		prepareNetlinkForSave(netlink) {
			// Check if we need to add missing required fields
			netlink.mission_id = netlink.mission_id || null;
			netlink.url_bought = netlink.url_bought || "";
			netlink.landing_page = netlink.landing_page || "";
			netlink.anchor_type = netlink.anchor_type || 1; // Default to "Semi optimisé"
			netlink.anchor = netlink.anchor || "";
			netlink.status = netlink.status !== undefined ? netlink.status : 0;

			// Allow null for link_type (empty option)
			netlink.link_type =
				netlink.link_type !== undefined ? netlink.link_type : null;

			netlink.contract_id = netlink.contract_id || this.contractId;
			netlink.society_name = netlink.society_name || this.societyName;

			// Use society_id from prop
			netlink.society_id = netlink.society_id || this.societyId;
			netlink.is_international =
				netlink.is_international !== undefined ? netlink.is_international : 0;
			netlink.is_billable =
				netlink.is_billable !== undefined ? netlink.is_billable : 0;

			// Allow null for provider_id (empty option)
			netlink.provider_id = netlink.provider_id || null;
			netlink.thema_id = netlink.thema_id || null;

			// Add API-required fields that might not be in your table UI
			netlink.domain_authority = netlink.domain_authority || 0;
			netlink.page_authority = netlink.page_authority || 0;
			netlink.trust_flow = netlink.trust_flow || 0;
			netlink.citation_flow = netlink.citation_flow || 0;
			netlink.external_links = netlink.external_links || 0;
			netlink.ref_domains = netlink.ref_domains || 0;
			netlink.user_id = this.activeUser.id;

			// ✅ UPDATED: sell_price handling - preserve database value or use calculated
			if (
				netlink.calculated_price !== undefined &&
				netlink.calculated_price !== null
			) {
				netlink.sell_price = netlink.calculated_price;
			} else if (netlink.price) {
				// Only calculate if we don't have a calculated_price
				netlink.sell_price = this.calculateSalePrice(
					netlink.price,
					netlink.mission_id
				);
			} else {
				netlink.sell_price = 0;
			}

			// Handle creation date
			if (!netlink.creation_date) {
				netlink.creation_date = new Date().toISOString().split("T")[0];
			}

			// Calculate renewal date based on creation date and renewal duration
			if (netlink.creation_date) {
				netlink.renew_date = this.calculateRenewDate(
					netlink.creation_date,
					netlink.renew_duration !== undefined ? netlink.renew_duration : 0
				);
			} else {
				if (netlink.renew_duration !== 0) {
					const creationDate = new Date(netlink.creation_date);
					const formattedDate = `${(creationDate.getMonth() + 1)
						.toString()
						.padStart(2, "0")}/${creationDate.getFullYear()}`;

					netlink.renew_date = this.calculateRenewDate(
						formattedDate,
						netlink.renew_duration !== undefined ? netlink.renew_duration : 0
					);
				} else {
					netlink.renew_date = null;
				}
			}

			// Handle other numeric fields
			netlink.price = netlink.price || 0;
			netlink.renew_duration =
				netlink.renew_duration !== undefined ? netlink.renew_duration : 0;

			// ✅ INCLURE le flag is_remove_purchase
			netlink.is_remove_purchase =
				netlink.is_remove_purchase !== undefined
					? netlink.is_remove_purchase
					: false;

			// ✅ NEW: Clean up temporary flags before saving
			delete netlink.isCalculatedPriceFromDB;
			delete netlink.isCalculatedPriceManual;
			delete netlink._isDuplicate;
			delete netlink._existingId;

			console.log("Preparing netlink for save:", netlink);
			return netlink;
		},
		hasNetlinkChanged(netlink) {
			// If it's a new netlink, it's changed by definition
			if (netlink._isNew) return true;

			// If we don't have the original data, assume it's changed
			if (!netlink.id || !this.originalNetlinks[netlink.id]) return true;

			const original = this.originalNetlinks[netlink.id];

			// Fields to ignore in comparison
			const ignoreFields = [
				"_isNew",
				"calculated_price",
				"margin",
				"_isDuplicate",
				"_existingId",
			];

			// Check each field for differences
			for (const key in netlink) {
				if (ignoreFields.includes(key)) continue;
				if (netlink[key] !== original[key]) {
					console.log(
						`Field '${key}' changed: ${original[key]} → ${netlink[key]}`
					);
					return true;
				}
			}

			return false;
		},
		// ✅ FIXED: handleStatusChange method with proper confirmation and grid refresh
		async handleStatusChange(event) {
			const newStatus = parseInt(event.newValue);
			const oldStatus = parseInt(event.oldValue);
			const rowData = event.data;

			// Get active status value
			const activeStatusValue = this.getActiveStatusValue();

			console.log(
				`Status change: ${oldStatus} -> ${newStatus}, active value: ${activeStatusValue}`
			);

			// Check if status changes TO actif (0) - check for duplicates and propose editing
			if (newStatus === 0 && oldStatus !== 0) {
				// Check for duplicates when changing to actif status
				const isDuplicate = this.checkNetlinkDuplicate({
					...rowData,
					status: newStatus,
				});

				if (isDuplicate) {
					// Find the existing duplicate netlink
					const existingNetlink = this.existingNetlinks.find((existing) => {
						return (
							existing.status === 0 &&
							existing.url_bought &&
							existing.url_bought.trim() === rowData.url_bought.trim() &&
							existing.landing_page &&
							existing.landing_page.trim() === rowData.landing_page.trim() &&
							existing.contract_id == rowData.contract_id &&
							existing.period_date == rowData.period_date
						);
					});

					if (existingNetlink) {
						// Show confirmation to edit existing or create new
						const shouldEditExisting = confirm(
							`Un netlink actif existe déjà avec les mêmes informations:\n\n` +
								`URL: ${existingNetlink.url_bought}\n` +
								`Landing Page: ${existingNetlink.landing_page}\n` +
								`Période: ${existingNetlink.period_date}\n\n` +
								`Voulez-vous modifier le netlink existant au lieu de créer un doublon ?`
						);

						if (shouldEditExisting) {
							// Revert status change
							event.node.setDataValue("status", oldStatus);

							// Show notification
							this.$vs.notify({
								title: "Modification recommandée",
								text: "Veuillez modifier le netlink existant au lieu de créer un doublon.",
								iconPack: "feather",
								icon: "edit",
								color: "primary",
								time: 5000,
							});
							return;
						}
					}
				}
			}

			// Check if status changes from "active" to something else
			if (oldStatus === activeStatusValue && newStatus !== activeStatusValue) {
				try {
					// ✅ FIXED: Show confirmation popup
					// const shouldRemovePurchase = await this.showStatusChangeConfirmation(
					// 	event
					// );
					const shouldRemovePurchase = false;

					// Add the is_remove_purchase flag to the data
					rowData.is_remove_purchase = shouldRemovePurchase;

					console.log(
						`Status changed from ${oldStatus} to ${newStatus}, remove purchase: ${shouldRemovePurchase}`
					);

					// Show notification to confirm the action
					// this.$vs.notify({
					// 	title: "Statut modifié",
					// 	text: shouldRemovePurchase
					// 		? "Le statut a été modifié. L'achat sera supprimé lors de l'enregistrement."
					// 		: "Le statut a été modifié. L'achat sera conservé.",
					// 	iconPack: "feather",
					// 	icon: "check-circle",
					// 	color: "primary",
					// });
				} catch (error) {
					// User cancelled, restore old status
					console.log("Status change cancelled, reverting...");

					// Restore old value
					event.node.setDataValue("status", oldStatus);

					// Refresh the cell to show the old value
					this.gridApi.refreshCells({
						rowNodes: [event.node],
						columns: ["status"],
						force: true,
					});

					this.$vs.notify({
						title: "Annulation",
						text: "Le changement de statut a été annulé",
						iconPack: "feather",
						icon: "x-circle",
						color: "warning",
					});
					return; // Exit early
				}
			} else {
				// If it's not a change from active to inactive, set false by default
				rowData.is_remove_purchase = false;

				// Show success notification for other status changes
				// this.$vs.notify({
				// 	title: "Statut modifié",
				// 	text: "Le statut a été modifié avec succès",
				// 	iconPack: "feather",
				// 	icon: "check-circle",
				// 	color: "success",
				// });
			}

			// ✅ FORCE COMPLETE GRID REFRESH to update editable states
			this.tableKey++;
		},

		// ✅ NOUVEAU : Afficher la popup de confirmation (version personnalisée)
		showStatusChangeConfirmation(event) {
			return new Promise((resolve, reject) => {
				this.currentStatusChangeEvent = event;
				this.statusChangeResolver = { resolve, reject };
				this.statusChangePopupActive = true;
			});
		},

		// ✅ NOUVEAU : Confirmer le changement de statut
		confirmStatusChange(removePurchase) {
			if (this.statusChangeResolver) {
				this.statusChangeResolver.resolve(removePurchase);
				this.statusChangeResolver = null;
			}
			this.statusChangePopupActive = false;
			this.currentStatusChangeEvent = null;
		},

		// ✅ NOUVEAU : Annuler le changement de statut
		cancelStatusChange() {
			if (this.statusChangeResolver) {
				this.statusChangeResolver.reject(new Error("Cancelled"));
				this.statusChangeResolver = null;
			}
			this.statusChangePopupActive = false;
			this.currentStatusChangeEvent = null;
		},

		// ✅ NOUVEAU : Version simple avec confirm() natif
		showSimpleStatusChangeConfirmation() {
			return new Promise((resolve) => {
				const result = confirm(
					"Le statut va passer à inactif.\n\nVoulez-vous supprimer l'achat associé à ce backlink ?\n\n✅ OK = Supprimer l'achat\n❌ Annuler = Conserver l'achat"
				);
				resolve(result);
			});
		},

		// ✅ NOUVEAU : Obtenir la valeur du statut "actif"
		getActiveStatusValue() {
			// Method 1: Look for "Actif" status
			const activeStatus = this.netlinkStatus.find(
				(status) =>
					status.status_text &&
					(status.status_text.toLowerCase().includes("actif") ||
						status.status_text.toLowerCase().includes("active"))
			);

			if (activeStatus) {
				return parseInt(activeStatus.status_value);
			}

			// Method 2: Default value (adapt according to your system)
			// Generally, 0 = active, 1 = inactive
			return 0;
		},

		isValidNetlink(netlink) {
			// Check if the netlink has the minimum required fields
			return (
				netlink &&
				netlink.url_bought &&
				netlink.url_bought.trim() !== "" &&
				netlink.landing_page &&
				netlink.landing_page.trim() !== "" &&
				netlink.mission_id &&
				netlink.society_id
			);
		},

		// Extract domain from URL for duplicate detection
		extractDomain(url) {
			if (!url || typeof url !== "string") {
				return null;
			}

			try {
				let cleanUrl = url.trim();

				// Add protocol if missing
				if (
					!cleanUrl.startsWith("http://") &&
					!cleanUrl.startsWith("https://")
				) {
					cleanUrl = `http://${cleanUrl}`;
				}

				const urlObj = new URL(cleanUrl);
				let domain = urlObj.hostname;

				// Remove www prefix
				if (domain.startsWith("www.")) {
					domain = domain.substring(4);
				}

				return domain.toLowerCase();
			} catch (error) {
				// If URL parsing fails, try to extract domain manually
				let domain = url
					.trim()
					.replace(/^https?:\/\//, "")
					.replace(/^www\./, "")
					.split("/")[0]
					.split("?")[0];
				return domain.toLowerCase();
			}
		},
		checkNetlinkDuplicate(netlink) {
			// Only check for duplicates if the new netlink is actif (status = 0)
			// Status 1 (en attente) can be created without duplicate checking since URL is incomplete
			if (
				!netlink.url_bought ||
				!netlink.landing_page ||
				netlink.status !== 0
			) {
				return false;
			}

			// Extract domain from the netlink being checked
			const currentDomain = this.extractDomain(netlink.url_bought);
			if (!currentDomain) {
				return false;
			}

			return this.existingNetlinks.some((existing) => {
				if (!existing.url_bought || !existing.landing_page) {
					return false;
				}

				// IMPORTANT: Skip self when checking duplicates (if editing existing netlink)
				if (netlink.id && existing.id === netlink.id) {
					return false;
				}

				// Only check against active netlinks (status = 0)
				if (existing.status !== 0) {
					return false;
				}

				// Extract domain from existing netlink
				const existingDomain = this.extractDomain(existing.url_bought);

				// Check for domain-level duplicates (same domain + contract + period)
				return (
					existingDomain === currentDomain &&
					existing.contract_id == netlink.contract_id &&
					existing.period_date == netlink.period_date
				);
			});
		},

		checkAndMarkDuplicate(netlink, rowIndex) {
			// Check if this netlink is a duplicate and mark it accordingly
			if (this.isValidNetlink(netlink)) {
				const isDuplicate = this.checkNetlinkDuplicate(netlink);

				// Update the duplicate flag
				this.$set(this.netlinks[rowIndex], "_isDuplicate", isDuplicate);

				// Force grid refresh to show styling changes
				if (this.gridApi) {
					this.gridApi.refreshCells({ force: true });
				}
			}
		},

		// Check domain existence via API
		async checkDomainExists(url_bought, society_id = null) {
			if (!url_bought || url_bought.trim() === "") {
				return;
			}

			try {
				const response = await Netlink.checkDomain(url_bought, society_id);

				if (
					response.success &&
					response.exists &&
					response.netlinks &&
					response.netlinks.length > 0
				) {
					// Build detailed message with existing netlinks
					let message = `Le domaine "${response.domain}" a déjà été dans le période ${response.netlinks[0].period_date}\n\n`;
					//period include

					// response.netlinks.forEach((nl, index) => {
					// 	message += `${index + 1}. Contrat: ${nl.contract_id}`;
					// 	if (nl.period_date) {
					// 		message += ` | Période: ${nl.period_date}`;
					// 	}
					// 	message += `\n   URL: ${nl.url_bought}\n`;
					// 	message += `   Landing: ${nl.landing_page}\n\n`;
					// });

					this.$vs.notify({
						title: "Attention: Domaine déjà acheté",
						text: message,
						iconPack: "feather",
						icon: "alert-triangle",
						color: "warning",
						time: 8000,
					});

					return true;
				}

				return false;
			} catch (error) {
				console.error("Error checking domain:", error);
				return false;
			}
		},

		saveNetlink(netlink) {
			// Prepare the netlink object for save (clean up any temporary fields)
			let netlinkToSave = { ...netlink };
			netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);
			delete netlinkToSave._isNew;
			delete netlinkToSave._isDuplicate;

			// If the netlink has an ID, it's an update, otherwise it's a creation
			if (netlinkToSave.id) {
				Netlink.updateNetlink(netlinkToSave.id, netlinkToSave)
					.then((res) => {
						this.$vs.notify({
							title: "Succès",
							text: "Netlink mis à jour avec succès",
							iconPack: "feather",
							icon: "check-circle",
							color: "success",
						});

						// Remove from modified list if exists
						const rowIndex = this.netlinks.findIndex(
							(n) => n.id === netlinkToSave.id
						);
						if (rowIndex !== -1) {
							this.modifiedRows.delete(rowIndex);
							// Remove duplicate flag if it was set
							this.$set(this.netlinks[rowIndex], "_isDuplicate", false);
						}
					})
					.catch((err) => {
						console.error(err);

						// Check if it's a 409 conflict (duplicate)
						if (err.response && err.response.status === 409) {
							const rowIndex = this.netlinks.findIndex(
								(n) => n.id === netlinkToSave.id
							);
							if (rowIndex !== -1) {
								// Mark as duplicate
								this.$set(this.netlinks[rowIndex], "_isDuplicate", true);
							}

							this.$vs.notify({
								title: "Doublon détecté",
								text: "Ce netlink existe déjà pour cette période et ce contrat",
								iconPack: "feather",
								icon: "alert-triangle",
								color: "warning",
								time: 6000,
							});
						} else {
							this.$vs.notify({
								title: "Erreur",
								text: "Une erreur est survenue lors de la mise à jour du netlink",
								iconPack: "feather",
								icon: "alert-circle",
								color: "danger",
							});
						}
					});
			} else {
				Netlink.createNetlink(netlinkToSave)
					.then((res) => {
						// Update the row with the ID from server
						const rowIndex = this.netlinks.findIndex((n) => n === netlink);
						if (rowIndex !== -1) {
							// Update the row with the new ID and remove _isNew flag
							this.$set(this.netlinks, rowIndex, {
								...netlinkToSave,
								id: res.id,
								_isDuplicate: false,
							});

							// Remove from new rows tracking
							this.newRows.delete(rowIndex);

							// Update the grid
							if (this.gridApi) {
								this.gridApi.refreshCells({ force: true });
							}
						}

						this.$vs.notify({
							title: "Succès",
							text: "Netlink créé avec succès",
							iconPack: "feather",
							icon: "check-circle",
							color: "success",
						});
					})
					.catch((err) => {
						console.error(err);

						// Check if it's a 409 conflict (duplicate)
						if (err.response && err.response.status === 409) {
							// Only show duplicate warning if the netlink is actif (status = 0)
							// For status 1 (en attente), allow creation since URL is incomplete
							if (netlink.status === 0) {
								// Mark the row as duplicate but keep it in the table
								const rowIndex = this.netlinks.findIndex((n) => n === netlink);
								if (rowIndex !== -1) {
									// Mark as duplicate
									this.$set(this.netlinks[rowIndex], "_isDuplicate", true);
									// Keep it in newRows so it shows as unsaved
									// this.newRows.add(rowIndex); // Already in newRows
								}

								this.$vs.notify({
									title: "Doublon détecté",
									text: `Ce netlink actif existe déjà: ${netlink.url_bought} -> ${netlink.landing_page} pour la période ${netlink.period_date}. Voulez-vous modifier l'existant ?`,
									iconPack: "feather",
									icon: "alert-triangle",
									color: "warning",
									time: 8000,
								});
							} else {
								// For status 1 (en attente), treat as successful creation
								// Update the row with success since URL is incomplete anyway
								const rowIndex = this.netlinks.findIndex((n) => n === netlink);
								if (rowIndex !== -1) {
									this.$set(this.netlinks[rowIndex], "_isDuplicate", false);
									this.newRows.delete(rowIndex);
								}

								this.$vs.notify({
									title: "Succès",
									text: "Netlink en attente créé avec succès (URL sera complétée plus tard)",
									iconPack: "feather",
									icon: "check-circle",
									color: "success",
								});
							}
						} else {
							this.$vs.notify({
								title: "Erreur",
								text: "Une erreur est survenue lors de la création du netlink",
								iconPack: "feather",
								icon: "alert-circle",
								color: "danger",
							});
						}
					});
			}
		},
		async deleteNetlink(netlink) {
			// Confirm dialog
			if (!confirm("Êtes-vous sûr de vouloir supprimer ce netlink ?")) {
				return;
			}

			if (netlink.id) {
				try {
					// If it has an ID, we need to delete it from the server
					await Netlink.deleteAsync(netlink.id);
					const index = this.netlinks.findIndex((n) => n.id === netlink.id);
					if (index !== -1) {
						this.netlinks.splice(index, 1);
						this.deletedRows.delete(index);
						this.modifiedRows.delete(index);

						// Update row data in the grid directly
						if (this.gridApi) {
							this.gridApi.setRowData(this.filteredNetlinks);
						}

						this.tableKey++; // Force refresh
					}

					// ✅ NOUVEAU : Refresh global store after delete
					try {
						await store.dispatch("getAllNetlink");
						console.log("✅ Store refreshed after delete");
					} catch (storeError) {
						console.error(
							"❌ Error refreshing store after delete:",
							storeError
						);
					}

					this.$vs.notify({
						title: "Succès",
						text: "Netlink supprimé avec succès",
						iconPack: "feather",
						icon: "check-circle",
						color: "success",
					});
				} catch (err) {
					console.error(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur est survenue lors de la suppression du netlink",
						iconPack: "feather",
						icon: "alert-circle",
						color: "danger",
					});
				}
			} else {
				// If it doesn't have an ID, we can just remove it from the UI
				const index = this.netlinks.findIndex((n) => n === netlink);
				if (index !== -1) {
					this.netlinks.splice(index, 1);
					this.newRows.delete(index);

					// Update row data in the grid directly
					if (this.gridApi) {
						this.gridApi.setRowData(this.filteredNetlinks);
					}

					this.tableKey++; // Force refresh
				}
			}
		},
		// ✅ UPDATED: saveAllChanges method with duplicate handling
		saveAllChanges() {
			this.duplicationConfirmationPopup = false;
			this.isSaving = true;

			// Stop any active editing
			if (this.gridApi) {
				this.gridApi.stopEditing();
			}

			// Get all rows that will be saved (both modified and new)
			// Modified rows are now tracked by netlink ID, not index
			const modifiedRowsData = Array.from(this.modifiedRows)
				.map((netlinkId) => {
					const netlink = this.netlinks.find((n) => n.id === netlinkId);
					if (netlink) {
						const index = this.netlinks.indexOf(netlink);
						return { data: netlink, index, isNew: false };
					}
					return null;
				})
				.filter((n) => n !== null);

			const newRowsData = Array.from(this.newRows)
				.map((index) => {
					if (index < this.netlinks.length) {
						return { data: this.netlinks[index], index, isNew: true };
					}
					return null;
				})
				.filter((n) => n !== null);
			// Don't filter by isValidNetlink here - let validation handle it later

			// ✅ NOUVEAU : Filter duplicates and non-duplicates
			const nonDuplicateNewRows = newRowsData.filter(
				(e) => e.data._isDuplicate == false
			);
			const duplicateNewRows = newRowsData.filter(
				(e) => e.data._isDuplicate == true
			);

			console.log("Processing rows:", {
				modified: modifiedRowsData.length,
				newNonDuplicate: nonDuplicateNewRows.length,
				newDuplicate: duplicateNewRows.length,
			});
			// debugger;

			const allRowsToSave = [
				...modifiedRowsData,
				...nonDuplicateNewRows,
				...duplicateNewRows,
			];

			// If no rows to save, show message and return
			if (allRowsToSave.length === 0) {
				this.isSaving = false;
				this.$vs.notify({
					title: "Information",
					text: "Aucune modification à enregistrer",
					iconPack: "feather",
					icon: "info",
					color: "primary",
				});
				return;
			}

			// Validate all rows - check for required fields
			const validationErrors = [];
			const requiredFields = [
				{ field: "mission_id", label: "Prestation" },
				{ field: "url_bought", label: "URL backlinks" },
				{ field: "landing_page", label: "URL landing" },
				{ field: "provider_id", label: "Prestataire" },
				{ field: "link_type", label: "Type de lien" },
				{ field: "price", label: "Prix d'achat HT" },
			];

			allRowsToSave.forEach((rowInfo, rowNumber) => {
				const data = rowInfo.data;
				const missingFields = [];

				requiredFields.forEach(({ field, label }) => {
					const value = data[field];
					// Check if field is empty (null, undefined, empty string, or 0 for non-numeric fields)
					if (field === "link_type") {
						// For link_type, 0 is a valid value, so only check for null/undefined
						if (value === null || value === undefined || value === "") {
							missingFields.push(label);
						}
					} else if (field === "price") {
						// For price, check if it's a valid number greater than or equal to 0
						if (
							value === null ||
							value === undefined ||
							value === "" ||
							isNaN(value) ||
							Number(value) < 0
						) {
							missingFields.push(label);
						}
					} else if (field === "provider_id") {
						// For provider_id, null/undefined/empty = missing
						console.log(`Checking provider_id for row  ${value}`);
						if (
							value === null ||
							value === undefined ||
							value === "" ||
							value == "null"
						) {
							missingFields.push(label);
						}
					} else if (field === "link_type") {
						// For link_type, null/undefined/empty = missing
						if (
							value === null ||
							value === undefined ||
							value === "" ||
							value == "null"
						) {
							missingFields.push(label);
						}
					} else {
						// For other fields, check for null, undefined, or empty string
						if (!value || value === "") {
							missingFields.push(label);
						}
					}
				});
				console.log("Validation errors found:", missingFields);
				if (missingFields.length > 0) {
					const rowType = rowInfo.isNew
						? "nouvelle ligne"
						: `ligne ${rowNumber + 1}`;
					validationErrors.push(`${rowType}: ${missingFields.join(", ")}`);
				}
			});

			// If there are validation errors, show them and stop
			if (validationErrors.length > 0) {
				this.isSaving = false;
				this.$vs.notify({
					title: "Champs obligatoires manquants",
					text: `Les champs suivants sont obligatoires:\n${validationErrors.join(
						"\n"
					)}`,
					iconPack: "feather",
					icon: "alert-circle",
					color: "danger",
					time: 8000, // Show longer for multiple errors
				});

				// Optionally, focus on the first error cell
				if (this.gridApi && allRowsToSave.length > 0) {
					const firstErrorRow = allRowsToSave[0];
					const firstMissingField = requiredFields.find(({ field }) => {
						const value = firstErrorRow.data[field];
						if (field === "provider_id" || field === "link_type") {
							return value === null || value === undefined || value === "";
						} else if (field === "price") {
							return !value || isNaN(value) || Number(value) <= 0;
						} else {
							return !value || value === "";
						}
					});

					if (firstMissingField) {
						this.gridApi.setFocusedCell(
							firstErrorRow.index,
							firstMissingField.field
						);
					}
				}

				return;
			}

			// Process modified rows, but only include those that have actually changed
			const modifiedNetlinks = modifiedRowsData
				.map((rowInfo) => {
					let netlinkToSave = { ...rowInfo.data };

					// Check if the netlink has actually been modified
					if (this.hasNetlinkChanged(netlinkToSave)) {
						// Prepare the netlink only if it was actually modified
						netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);
						return netlinkToSave;
					}

					// Not modified, return null to filter it out
					console.log(
						`Netlink ID ${netlinkToSave.id} not modified, skipping update`
					);
					return null;
				})
				.filter((n) => n !== null);

			console.log(
				`${modifiedNetlinks.length} truly modified netlinks will be updated`
			);

			// Only create promises for netlinks that were actually changed
			const savePromises = modifiedNetlinks.map((netlink) => {
				delete netlink._isNew;
				delete netlink._isDuplicate;
				delete netlink._existingId;
				return Netlink.updateNetlink(netlink.id, netlink);
			});

			// ✅ NOUVEAU : Process duplicate new rows (updates to existing records)
			const duplicateNetlinks = duplicateNewRows
				.map((rowInfo) => {
					let netlinkToSave = { ...rowInfo.data };
					netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);
					console.log("NEW Duplicate rows", netlinkToSave);
					// debugger;

					// ✅ CRITICAL: Use the existing ID for updates
					netlinkToSave.id = rowInfo.data._existingId;

					return netlinkToSave;
				})
				.filter((n) => n !== null);

			console.log(duplicateNetlinks);
			// debugger;

			const editDuplicatePromises = duplicateNetlinks.map((netlink) => {
				delete netlink._isNew;
				delete netlink._isDuplicate;
				delete netlink._existingId;
				return Netlink.updateNetlink(netlink.id, netlink);
			});

			// Process new rows (no change here, new rows are always saved)
			const newNetlinks = nonDuplicateNewRows
				.map((rowInfo) => {
					let netlinkToSave = { ...rowInfo.data };
					netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);
					return netlinkToSave;
				})
				.filter((n) => n !== null);

			const createPromises = newNetlinks.map((netlink) => {
				delete netlink._isNew;
				delete netlink._isDuplicate;
				delete netlink._existingId;
				return Netlink.createNetlink(netlink);
			});

			// ✅ NOUVEAU : Include all promises in the execution
			const allPromises = [
				...savePromises,
				...editDuplicatePromises,
				...createPromises,
			];

			// If there are no changes to save after filtering, show a message and return
			if (allPromises.length === 0) {
				this.isSaving = false;
				this.$vs.notify({
					title: "Information",
					text: "Aucune modification à enregistrer",
					iconPack: "feather",
					icon: "info",
					color: "primary",
				});

				// Reset tracking since there are no actual changes
				this.resetChangeTracking();
				return;
			}

			// Save all changes
			Promise.all(allPromises)
				.then(async (results) => {
					// Handle results for new records (assigns new IDs)
					const createStartIndex =
						savePromises.length + editDuplicatePromises.length;
					results.forEach((result, index) => {
						if (result && result.id && index >= createStartIndex) {
							// This is a newly created record
							const newRowIndex = Array.from(this.newRows)[
								index - createStartIndex
							];
							if (
								newRowIndex !== undefined &&
								newRowIndex < this.netlinks.length
							) {
								// Update the netlink with its new ID
								const updatedNetlink = {
									...this.netlinks[newRowIndex],
									id: result.id,
									_isNew: false,
									_isDuplicate: false,
								};
								delete updatedNetlink._existingId;

								// Also save to originalNetlinks for future comparisons
								this.originalNetlinks[result.id] = JSON.parse(
									JSON.stringify(updatedNetlink)
								);

								// Update in the data array
								this.$set(this.netlinks, newRowIndex, updatedNetlink);
							}
						}
					});

					// Update original data for modified rows as well
					[...modifiedNetlinks, ...duplicateNetlinks].forEach((netlink) => {
						if (netlink.id) {
							this.originalNetlinks[netlink.id] = JSON.parse(
								JSON.stringify(netlink)
							);
						}
					});

					// ✅ NOUVEAU : Refresh global store after successful saves
					try {
						console.log("🔄 Refreshing global store after save...");
						await store.dispatch("getAllNetlink");
						console.log("✅ Global store refreshed successfully");
					} catch (storeError) {
						console.error("❌ Error refreshing store:", storeError);
					}

					this.$vs.notify({
						title: "Succès",
						text: `Modifications enregistrées (${savePromises.length} mises à jour, ${editDuplicatePromises.length} doublons mis à jour, ${createPromises.length} créations)`,
						iconPack: "feather",
						icon: "check-circle",
						color: "success",
					});

					// Reset tracking
					this.resetChangeTracking();
					this.duplicationConfirmationPopup = false;
					this.isSaving = false;

					// Emit event to notify parent component to refresh data
					this.$emit("data-updated");
				})
				.catch((err) => {
					console.error("Save error:", err);
					this.isSaving = false;
					this.$vs.notify({
						title: "Erreur",
						text:
							"Une erreur est survenue lors de l'enregistrement des modifications. Détails: " +
							(err.message || "Erreur inconnue"),
						iconPack: "feather",
						icon: "alert-circle",
						color: "danger",
						time: 5000,
					});
				});
		},
		onBtStopEditing() {
			if (this.gridApi) {
				this.gridApi.stopEditing();
			}
		},
		onBtStartEditing() {
			if (this.netlinks.length > 1 && this.gridApi) {
				this.gridApi.setFocusedCell(1, "provider_id");
				this.gridApi.startEditingCell({
					rowIndex: 1,
					colKey: "provider_id",
				});
			}
		},
		onGridReady(params) {
			this.gridApi = params.api;

			// Debug information
			console.log("Grid ready with data:", {
				providers: this.providers.length,
				linkTypes: this.linkTypes.length,
				netlinkStatus: this.netlinkStatus.length,
				anchorTypes: this.anchorTypes.length,
			});
		},
		onSelectionChanged() {
			if (!this.gridApi) return;

			const selectedNodes = this.gridApi.getSelectedNodes();
			this.selectedRows.clear();
			this.selectedRowsData = [];

			selectedNodes.forEach((node) => {
				if (node.data) {
					this.selectedRows.add(node.data.id || node.id);
					this.selectedRowsData.push(node.data);
				}
			});

			console.log("Selection changed:", {
				selectedCount: this.selectedRows.size,
				totalPA: this.totalBuyPrice,
				totalPV: this.totalSellPrice,
			});
		},
	},
};
</script>
<style scoped>
.price-totals {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	padding: 8px 16px;
	background-color: #f0f9ff;
	border-radius: 6px;
	border: 1px solid #08b0b9;
	margin-right: 8px;
}

.total-item {
	font-size: 14px;
	color: #333;
}

.total-item strong {
	color: #08b0b9;
	margin-right: 4px;
}

.divider {
	color: #ccc;
	font-weight: 300;
}

.example-wrapper {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.button-container {
	display: flex;
	gap: 10px;
	margin-bottom: 10px;
}

.action-button {
	padding: 8px 16px;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f8f8f8;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.2s;
}

:hover {
	background-color: #45a049;
}

button {
	margin-right: 10px;
	padding: 5px 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f8f8f8;
	cursor: pointer;
}

button:hover {
	background-color: #e8e8e8;
}

.action-buttons {
	display: flex;
	gap: 5px;
}

.btn-icon {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	cursor: pointer;
}

.btn-save {
	background-color: #4caf50;
	color: white;
}

.btn-delete {
	background-color: #f44336;
	color: white;
}

.btn-clear {
	background-color: #ff9800;
	color: white;
}

/* ✅ NOUVEAU : Styles pour les filtres */
.filter-section {
	margin-bottom: 15px;
	padding: 10px;
	background-color: #f9f9f9;
	border-radius: 5px;
	border: 1px solid #eee;
}

.filter-section h4 {
	margin-top: 0;
	margin-bottom: 10px;
	color: #333;
}

.filter-row {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 10px;
}

.filter-item {
	flex: 1;
	max-width: 250px;
}

.filter-item label {
	display: block;
	margin-bottom: 5px;
	font-size: 14px;
	color: #666;
}

.filter-item input,
.filter-item select {
	width: 100%;
	padding: 8px;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
}

.filter-item input:focus,
.filter-item select:focus {
	border-color: #1976d2;
	outline: none;
}

.flex-row {
	display: flex;
	gap: 10px;
}

.mt-2 {
	margin-top: 10px;
}

.loader-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
}

@media (max-width: 768px) {
	.filter-item {
		min-width: 100%;
	}
}

/* ✅ NOUVEAU : Styles pour le month picker */
/* .period-picker-container .month-picker-input:focus {
	border-color: #1976d2;
	outline: none;
} */

/* Month picker dropdown positioning */
.month-picker__container {
	z-index: 9999 !important;
}

/* Toggle checkbox styling */
.filter-item label small {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.filter-item label small input[type="checkbox"] {
	margin: 0;
	transform: scale(0.8);
}

/* Clear button for month picker */
/* .period-picker-container::after {
	content: "×";
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	font-size: 18px;
	color: #666;
	display: none;
}

.period-picker-container:hover::after {
	display: block;
} */

.status-change-popup .popup-content {
	text-align: center;
	padding: 20px;
}

.status-change-popup .warning-icon {
	margin-bottom: 20px;
}

.status-change-popup h3 {
	color: #333;
	margin-bottom: 15px;
	font-size: 18px;
}

.status-change-popup p {
	color: #666;
	margin-bottom: 25px;
	font-size: 16px;
}

.status-change-popup .popup-actions {
	display: flex;
	gap: 10px;
	justify-content: center;
	flex-wrap: wrap;
}

/* 🔹 NEW: Flex utility classes */
.flex {
	display: flex;
}

.gap-4 {
	gap: 1rem;
}
</style>